//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const BASE_URL = new InjectionToken<string>('BASE_URL');

@Injectable()
export class ProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Accept terms and conditions
     * @return Terms and conditions accepted successfully
     */
    acceptTermsAndConditions(): Observable<AcceptTermsAndConditionsResponse> {
        let url_ = this.baseUrl + "/api/profile/terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTermsAndConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTermsAndConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcceptTermsAndConditionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcceptTermsAndConditionsResponse>;
        }));
    }

    protected processAcceptTermsAndConditions(response: HttpResponseBase): Observable<AcceptTermsAndConditionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcceptTermsAndConditionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User not authenticated", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get user profile information
     * @return Profile information retrieved successfully
     */
    getProfile(): Observable<GetProfileResponse> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfileResponse>;
        }));
    }

    protected processGetProfile(response: HttpResponseBase): Observable<GetProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User not authenticated", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update user profile information
     * @return Profile updated successfully
     */
    updateProfile(updateProfileRequest: UpdateProfileRequest): Observable<UpdateProfileResponse> {
        let url_ = this.baseUrl + "/api/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProfileRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProfileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProfileResponse>;
        }));
    }

    protected processUpdateProfile(response: HttpResponseBase): Observable<UpdateProfileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProfileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User not authenticated", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganisationConfigurationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets MyLab organisation configuration
     * @return The organisation configuration has been retrieved successfully
     */
    getOrganisationConfiguration(limbusOrganisationId: number): Observable<OrganisationConfigurationResponse> {
        let url_ = this.baseUrl + "/api/admin/organisation/{limbusOrganisationId}/configuration";
        if (limbusOrganisationId === undefined || limbusOrganisationId === null)
            throw new Error("The parameter 'limbusOrganisationId' must be defined.");
        url_ = url_.replace("{limbusOrganisationId}", encodeURIComponent("" + limbusOrganisationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganisationConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganisationConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationConfigurationResponse>;
        }));
    }

    protected processGetOrganisationConfiguration(response: HttpResponseBase): Observable<OrganisationConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates MyLab organisation configuration
     * @param limbusOrganisationId Gets or sets the Limbus organisation identifier bound from the route.
     * @param configuration Gets or sets the complete flat JSON configuration body.
     * @return The organisation configuration has been updated successfully
     */
    updateOrganisationConfiguration(limbusOrganisationId: number, configuration: UpdateOrganisationConfigurationRequest | null): Observable<OrganisationConfigurationResponse> {
        let url_ = this.baseUrl + "/api/admin/organisation/{limbusOrganisationId}/configuration";
        if (limbusOrganisationId === undefined || limbusOrganisationId === null)
            throw new Error("The parameter 'limbusOrganisationId' must be defined.");
        url_ = url_.replace("{limbusOrganisationId}", encodeURIComponent("" + limbusOrganisationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configuration);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganisationConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganisationConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganisationConfigurationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganisationConfigurationResponse>;
        }));
    }

    protected processUpdateOrganisationConfiguration(response: HttpResponseBase): Observable<OrganisationConfigurationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationConfigurationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("The configuration changed after the caller loaded it", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrderHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns requested sampling and container supplies for an authorised recent work item.
     * @param orderIdJobNumber Gets or sets the raw `{orderId},{jobNumber}` route segment.
     * @param includeAllJobsInOrganisation Gets or sets the ignored legacy list-expansion parameter.
     * @return Success
     */
    getSamplingItems(orderIdJobNumber: string | null, includeAllJobsInOrganisation: boolean): Observable<OrderSamplingItem[]> {
        let url_ = this.baseUrl + "/api/orders/{orderIdJobNumber}/sampling-items?";
        if (orderIdJobNumber === undefined || orderIdJobNumber === null)
            throw new Error("The parameter 'orderIdJobNumber' must be defined.");
        url_ = url_.replace("{orderIdJobNumber}", encodeURIComponent("" + orderIdJobNumber));
        if (includeAllJobsInOrganisation === undefined || includeAllJobsInOrganisation === null)
            throw new Error("The parameter 'includeAllJobsInOrganisation' must be defined and cannot be null.");
        else
            url_ += "includeAllJobsInOrganisation=" + encodeURIComponent("" + includeAllJobsInOrganisation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSamplingItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSamplingItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderSamplingItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderSamplingItem[]>;
        }));
    }

    protected processGetSamplingItems(response: HttpResponseBase): Observable<OrderSamplingItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrderSamplingItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets authorised recent order detail, samples, and requested tests
     * @param orderIdJobNumber Gets or sets the raw `{orderId},{jobNumber}` route segment.
     * @param includeAllJobsInOrganisation Gets or sets the ignored legacy list-expansion parameter.
     * @param dispatchTaskId (optional) Gets or sets an optional dispatch-task selection.
     * @return Success
     */
    getOrderDetail(orderIdJobNumber: string | null, includeAllJobsInOrganisation: boolean, dispatchTaskId?: number | null | undefined): Observable<GetOrderDetailResponse> {
        let url_ = this.baseUrl + "/api/orders/{orderIdJobNumber}?";
        if (orderIdJobNumber === undefined || orderIdJobNumber === null)
            throw new Error("The parameter 'orderIdJobNumber' must be defined.");
        url_ = url_.replace("{orderIdJobNumber}", encodeURIComponent("" + orderIdJobNumber));
        if (includeAllJobsInOrganisation === undefined || includeAllJobsInOrganisation === null)
            throw new Error("The parameter 'includeAllJobsInOrganisation' must be defined and cannot be null.");
        else
            url_ += "includeAllJobsInOrganisation=" + encodeURIComponent("" + includeAllJobsInOrganisation) + "&";
        if (dispatchTaskId !== undefined && dispatchTaskId !== null)
            url_ += "dispatchTaskId=" + encodeURIComponent("" + dispatchTaskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderDetailResponse>;
        }));
    }

    protected processGetOrderDetail(response: HttpResponseBase): Observable<GetOrderDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets authorised recent order previews
     * @param includeAllJobsInOrganisation Gets or sets whether organisation and delegated relationship candidates are included.
     * @return Success
     */
    getOrderPreviews(includeAllJobsInOrganisation: boolean): Observable<GetOrderPreviewsResponse> {
        let url_ = this.baseUrl + "/api/orders/orderPreviews?";
        if (includeAllJobsInOrganisation === undefined || includeAllJobsInOrganisation === null)
            throw new Error("The parameter 'includeAllJobsInOrganisation' must be defined and cannot be null.");
        else
            url_ += "includeAllJobsInOrganisation=" + encodeURIComponent("" + includeAllJobsInOrganisation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderPreviewsResponse>;
        }));
    }

    protected processGetOrderPreviews(response: HttpResponseBase): Observable<GetOrderPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets authorised recent jobs and pre-registered orders
     * @param includeAllJobsInOrganisation Gets or sets whether organisation and delegated relationship candidates are included.
     * @return Success
     */
    getOrders(includeAllJobsInOrganisation: boolean): Observable<GetOrdersResponse> {
        let url_ = this.baseUrl + "/api/orders?";
        if (includeAllJobsInOrganisation === undefined || includeAllJobsInOrganisation === null)
            throw new Error("The parameter 'includeAllJobsInOrganisation' must be defined and cannot be null.");
        else
            url_ += "includeAllJobsInOrganisation=" + encodeURIComponent("" + includeAllJobsInOrganisation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersResponse>;
        }));
    }

    protected processGetOrders(response: HttpResponseBase): Observable<GetOrdersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrdersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Searches authorised recent jobs and pre-registered orders
     * @return Success
     */
    searchOrders(orderSearchRequest: OrderSearchRequest): Observable<GetOrdersResponse> {
        let url_ = this.baseUrl + "/api/orders/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderSearchRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrdersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrdersResponse>;
        }));
    }

    protected processSearchOrders(response: HttpResponseBase): Observable<GetOrdersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrdersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OnlineIdentitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new online identity user
     * @return The online identity has been created successfully
     */
    createOnlineIdentity(createOnlineIdentityRequest: CreateOnlineIdentityRequest): Observable<CreateOnlineIdentityResponse> {
        let url_ = this.baseUrl + "/api/admin/online-identities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOnlineIdentityRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOnlineIdentity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOnlineIdentity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOnlineIdentityResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOnlineIdentityResponse>;
        }));
    }

    protected processCreateOnlineIdentity(response: HttpResponseBase): Observable<CreateOnlineIdentityResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOnlineIdentityResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the status of an online identity for a contact
     * @return The online identity status has been retrieved successfully
     */
    getOnlineIdentityStatus(limbusContactId: number): Observable<OnlineIdentityStatusResponse> {
        let url_ = this.baseUrl + "/api/admin/online-identities/{limbusContactId}";
        if (limbusContactId === undefined || limbusContactId === null)
            throw new Error("The parameter 'limbusContactId' must be defined.");
        url_ = url_.replace("{limbusContactId}", encodeURIComponent("" + limbusContactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineIdentityStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineIdentityStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnlineIdentityStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnlineIdentityStatusResponse>;
        }));
    }

    protected processGetOnlineIdentityStatus(response: HttpResponseBase): Observable<OnlineIdentityStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnlineIdentityStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a reset password email to a contact's online identity
     * @return The reset password email has been sent successfully
     */
    sendResetPasswordEmail(limbusContactId: number): Observable<SendResetPasswordEmailResponse> {
        let url_ = this.baseUrl + "/api/admin/online-identities/{limbusContactId}/send-reset-password-email";
        if (limbusContactId === undefined || limbusContactId === null)
            throw new Error("The parameter 'limbusContactId' must be defined.");
        url_ = url_.replace("{limbusContactId}", encodeURIComponent("" + limbusContactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResetPasswordEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResetPasswordEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendResetPasswordEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendResetPasswordEmailResponse>;
        }));
    }

    protected processSendResetPasswordEmail(response: HttpResponseBase): Observable<SendResetPasswordEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendResetPasswordEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends a verification email to a contact's online identity
     * @return The verification email has been sent successfully
     */
    sendVerificationEmail(limbusContactId: number): Observable<SendVerificationEmailResponse> {
        let url_ = this.baseUrl + "/api/admin/online-identities/{limbusContactId}/send-verification-email";
        if (limbusContactId === undefined || limbusContactId === null)
            throw new Error("The parameter 'limbusContactId' must be defined.");
        url_ = url_.replace("{limbusContactId}", encodeURIComponent("" + limbusContactId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendVerificationEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendVerificationEmailResponse>;
        }));
    }

    protected processSendVerificationEmail(response: HttpResponseBase): Observable<SendVerificationEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendVerificationEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LabOrdersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Adds a lab test to the user's favourites
     * @return Favourite successfully added
     */
    addFavouriteLabTest(catalogueItemId: string | null): Observable<any> {
        let url_ = this.baseUrl + "/api/lab-orders/lab-tests/{catalogueItemId}/favourite";
        if (catalogueItemId === undefined || catalogueItemId === null)
            throw new Error("The parameter 'catalogueItemId' must be defined.");
        url_ = url_.replace("{catalogueItemId}", encodeURIComponent("" + catalogueItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFavouriteLabTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFavouriteLabTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAddFavouriteLabTest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Remove a lab test from the user's favourites
     * @return Favourite successfully removed
     */
    removeFavouriteLabTest(catalogueItemId: number): Observable<any> {
        let url_ = this.baseUrl + "/api/lab-orders/lab-tests/{catalogueItemId}/favourite";
        if (catalogueItemId === undefined || catalogueItemId === null)
            throw new Error("The parameter 'catalogueItemId' must be defined.");
        url_ = url_.replace("{catalogueItemId}", encodeURIComponent("" + catalogueItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveFavouriteLabTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveFavouriteLabTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processRemoveFavouriteLabTest(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add favourite sample type
     * @param sampleTypeId The sampleTypeId of the sample type to favourite
     * @return Sample type has successfully been favourited
     */
    addFavouriteSampleType(sampleTypeId: string | null): Observable<AddFavouriteSampleTypeResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/sample-types/{sampleTypeId}/favourite";
        if (sampleTypeId === undefined || sampleTypeId === null)
            throw new Error("The parameter 'sampleTypeId' must be defined.");
        url_ = url_.replace("{sampleTypeId}", encodeURIComponent("" + sampleTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFavouriteSampleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFavouriteSampleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFavouriteSampleTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFavouriteSampleTypeResponse>;
        }));
    }

    protected processAddFavouriteSampleType(response: HttpResponseBase): Observable<AddFavouriteSampleTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFavouriteSampleTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorised", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete favourite sample type
     * @param sampleTypeId The sampleTypeId of the sample type to unfavourite
     * @return Sample type has successfully been unfavourited
     */
    deleteFavouriteSampleType(sampleTypeId: string | null): Observable<DeleteFavouriteSampleTypeResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/sample-types/{sampleTypeId}/favourite";
        if (sampleTypeId === undefined || sampleTypeId === null)
            throw new Error("The parameter 'sampleTypeId' must be defined.");
        url_ = url_.replace("{sampleTypeId}", encodeURIComponent("" + sampleTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFavouriteSampleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFavouriteSampleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFavouriteSampleTypeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFavouriteSampleTypeResponse>;
        }));
    }

    protected processDeleteFavouriteSampleType(response: HttpResponseBase): Observable<DeleteFavouriteSampleTypeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFavouriteSampleTypeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorised", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Claim an Order
     * @param orderId The orderId of the order to claim
     * @return The orderId and the authId of the user
     */
    claimOrder(orderId: string | null): Observable<ClaimOrderResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders/{orderId}/claim";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClaimOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClaimOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClaimOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClaimOrderResponse>;
        }));
    }

    protected processClaimOrder(response: HttpResponseBase): Observable<ClaimOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClaimOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an Order
     * @return The orderId of the newly created order
     */
    createOrder(createOrderRequest: CreateOrderRequest): Observable<CreateOrderResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createOrderRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOrderResponse>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<CreateOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an Order
     * @param orderId The orderId of the order to delete
     * @return Order successfully marked for deletion
     */
    deleteOrder(orderId: string): Observable<any> {
        let url_ = this.baseUrl + "/api/lab-orders/orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processDeleteOrder(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an existing Order
     * @param orderId The unique ID of the order
     * @return The order details
     */
    getOrder(orderId: string): Observable<GetOrderResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderResponse>;
        }));
    }

    protected processGetOrder(response: HttpResponseBase): Observable<GetOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Laboratory Order that's not yet submitted
     * @return Success
     */
    updateOrder(orderId: string, updateOrderRequest: UpdateOrderRequest): Observable<UpdateOrderResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrderResponse>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<UpdateOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns laboratory test details
     * @return A laboratory test detail
     */
    getLaboratoryTestDetails(catalogueItemId: number): Observable<GetLaboratoryTestDetailsResponse> {
        let url_ = this.baseUrl + "/api/lab-tests/{catalogueItemId}";
        if (catalogueItemId === undefined || catalogueItemId === null)
            throw new Error("The parameter 'catalogueItemId' must be defined.");
        url_ = url_.replace("{catalogueItemId}", encodeURIComponent("" + catalogueItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLaboratoryTestDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLaboratoryTestDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLaboratoryTestDetailsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLaboratoryTestDetailsResponse>;
        }));
    }

    protected processGetLaboratoryTestDetails(response: HttpResponseBase): Observable<GetLaboratoryTestDetailsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLaboratoryTestDetailsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns analytical tests based on a set of persona ids
     * @return A list of lab test summaries
     */
    getLabTests(organisationGroupIds: number[] | null): Observable<GetLabTestsResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/lab-tests?";
        if (organisationGroupIds === undefined)
            throw new Error("The parameter 'organisationGroupIds' must be defined.");
        else if(organisationGroupIds !== null)
            organisationGroupIds && organisationGroupIds.forEach(item => { url_ += "organisationGroupIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLabTestsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLabTestsResponse>;
        }));
    }

    protected processGetLabTests(response: HttpResponseBase): Observable<GetLabTestsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLabTestsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get sample parameters for an order
     * @param orderId The unique ID of the order
     * @return The order sample parameter details
     */
    getOrderSampleParameters(orderId: string): Observable<GetOrderSampleParametersResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/order/{orderId}/sample-parameters";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderSampleParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderSampleParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderSampleParametersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderSampleParametersResponse>;
        }));
    }

    protected processGetOrderSampleParameters(response: HttpResponseBase): Observable<GetOrderSampleParametersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderSampleParametersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Laboratory Order that's not yet submitted
     * @return Success
     */
    updateOrderSampleParameters(orderId: string, updateOrderSampleParametersRequest: UpdateOrderSampleParametersRequest): Observable<UpdateOrderSampleParametersResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/order/{orderId}/sample-parameters";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateOrderSampleParametersRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderSampleParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderSampleParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateOrderSampleParametersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateOrderSampleParametersResponse>;
        }));
    }

    protected processUpdateOrderSampleParameters(response: HttpResponseBase): Observable<UpdateOrderSampleParametersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateOrderSampleParametersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get order template for an order
     * @param orderTemplateId The unique ID of the order
     * @param includePricing (optional) Whether Limbus calculates template line prices; omitted requests retain the priced behavior.
     * @return The order template details
     */
    getOrderTemplate(orderTemplateId: string, includePricing?: boolean | undefined): Observable<GetOrderTemplateResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/order-templates/{orderTemplateId}?";
        if (orderTemplateId === undefined || orderTemplateId === null)
            throw new Error("The parameter 'orderTemplateId' must be defined.");
        url_ = url_.replace("{orderTemplateId}", encodeURIComponent("" + orderTemplateId));
        if (includePricing === null)
            throw new Error("The parameter 'includePricing' cannot be null.");
        else if (includePricing !== undefined)
            url_ += "includePricing=" + encodeURIComponent("" + includePricing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderTemplateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderTemplateResponse>;
        }));
    }

    protected processGetOrderTemplate(response: HttpResponseBase): Observable<GetOrderTemplateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderTemplateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns lab tests for an order template
     * @param orderTemplateId The unique ID of the order template
     * @param offset The number of items to skip (for pagination)
     * @param limit The maximum number of items to return (for pagination)
     * @param name (optional) Optional search term to filter lab tests by name or code (minimum 2 characters)
     * @return A paginated list of lab tests
     */
    getOrderTemplateLabTests(orderTemplateId: string, offset: number, limit: number, name?: string | null | undefined): Observable<PaginatedResultOfOrderTemplateLabTestSummaryRest> {
        let url_ = this.baseUrl + "/api/lab-orders/order-template/{orderTemplateId}/lab-tests?";
        if (orderTemplateId === undefined || orderTemplateId === null)
            throw new Error("The parameter 'orderTemplateId' must be defined.");
        url_ = url_.replace("{orderTemplateId}", encodeURIComponent("" + orderTemplateId));
        if (offset === undefined || offset === null)
            throw new Error("The parameter 'offset' must be defined and cannot be null.");
        else
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === undefined || limit === null)
            throw new Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderTemplateLabTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTemplateLabTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaginatedResultOfOrderTemplateLabTestSummaryRest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaginatedResultOfOrderTemplateLabTestSummaryRest>;
        }));
    }

    protected processGetOrderTemplateLabTests(response: HttpResponseBase): Observable<PaginatedResultOfOrderTemplateLabTestSummaryRest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedResultOfOrderTemplateLabTestSummaryRest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns compatible sample types for an order template
     * @return A list of sample types
     */
    getOrderTemplateSampleTypes(orderTemplateId: string): Observable<GetOrderTemplateSampleTypesResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/order-template/{orderTemplateId}/sample-types";
        if (orderTemplateId === undefined || orderTemplateId === null)
            throw new Error("The parameter 'orderTemplateId' must be defined.");
        url_ = url_.replace("{orderTemplateId}", encodeURIComponent("" + orderTemplateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderTemplateSampleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderTemplateSampleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderTemplateSampleTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderTemplateSampleTypesResponse>;
        }));
    }

    protected processGetOrderTemplateSampleTypes(response: HttpResponseBase): Observable<GetOrderTemplateSampleTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderTemplateSampleTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an existing Order with prices
     * @param orderId The unique ID of the order
     * @return The order details
     */
    getOrderWithPrice(orderId: string): Observable<GetOrderWithPriceResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders-with-price/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderWithPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderWithPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrderWithPriceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrderWithPriceResponse>;
        }));
    }

    protected processGetOrderWithPrice(response: HttpResponseBase): Observable<GetOrderWithPriceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrderWithPriceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a list of recommended sampling items for an order
     * @return A list of the recommended sampling items
     */
    getRecommendedSamplingItems(orderId: string): Observable<GetRecommendedSamplingItemsResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/{orderId}/recommended-sampling-supplies";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecommendedSamplingItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecommendedSamplingItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecommendedSamplingItemsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecommendedSamplingItemsResponse>;
        }));
    }

    protected processGetRecommendedSamplingItems(response: HttpResponseBase): Observable<GetRecommendedSamplingItemsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecommendedSamplingItemsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns recommended lab tests
     * @return A list of recommended lab test
     */
    getRecommendedTests(sampleTypeId: number): Observable<GetRecommendTestsResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/{sampleTypeId}/recommended-tests";
        if (sampleTypeId === undefined || sampleTypeId === null)
            throw new Error("The parameter 'sampleTypeId' must be defined.");
        url_ = url_.replace("{sampleTypeId}", encodeURIComponent("" + sampleTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecommendedTests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecommendedTests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecommendTestsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecommendTestsResponse>;
        }));
    }

    protected processGetRecommendedTests(response: HttpResponseBase): Observable<GetRecommendTestsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecommendTestsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns compatible sample types that are common to a set of catalogue items.
     * @return A list of sample types
     */
    getSampleTypesByCatalogueItems(getSampleTypesByCatalogueItemsRequest: GetSampleTypesByCatalogueItemsRequest): Observable<GetSampleTypesByCatalogueItemsResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/sample-types/by-catalogue-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSampleTypesByCatalogueItemsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleTypesByCatalogueItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleTypesByCatalogueItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSampleTypesByCatalogueItemsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSampleTypesByCatalogueItemsResponse>;
        }));
    }

    protected processGetSampleTypesByCatalogueItems(response: HttpResponseBase): Observable<GetSampleTypesByCatalogueItemsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSampleTypesByCatalogueItemsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns compatible sample types that are applicable to a set of organisation groups.
     * @return A list of sample types
     */
    getSampleTypesByOrganisationGroups(getSampleTypesByOrganisationGroupsRequest: GetSampleTypesByOrganisationGroupsRequest): Observable<GetSampleTypesByOrganisationGroupsResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/sample-types/by-organisation-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSampleTypesByOrganisationGroupsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleTypesByOrganisationGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleTypesByOrganisationGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSampleTypesByOrganisationGroupsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSampleTypesByOrganisationGroupsResponse>;
        }));
    }

    protected processGetSampleTypesByOrganisationGroups(response: HttpResponseBase): Observable<GetSampleTypesByOrganisationGroupsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSampleTypesByOrganisationGroupsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns sample types with matching sample type codes. This only returns sample types that are active and allowed for the user.
     * @return A list of sample types
     */
    getSampleTypesBySampleTypeCodes(getSampleTypesBySampleTypeCodesRequest: GetSampleTypesBySampleTypeCodesRequest): Observable<GetSampleTypesBySampleTypeCodesResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/sample-types/by-sample-type-codes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getSampleTypesBySampleTypeCodesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleTypesBySampleTypeCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleTypesBySampleTypeCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSampleTypesBySampleTypeCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSampleTypesBySampleTypeCodesResponse>;
        }));
    }

    protected processGetSampleTypesBySampleTypeCodes(response: HttpResponseBase): Observable<GetSampleTypesBySampleTypeCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSampleTypesBySampleTypeCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Submit an order
     * @return The MyLab order ID and the reserved Limbus order ID for the submitted order
     */
    submitOrder(orderId: string | null): Observable<SubmitOrderResponse> {
        let url_ = this.baseUrl + "/api/lab-orders/orders/{orderId}/submit";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmitOrderResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmitOrderResponse>;
        }));
    }

    protected processSubmitOrder(response: HttpResponseBase): Observable<SubmitOrderResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitOrderResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SamplingSupplyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get the sampling supply id
     * @param code The unique ID of the order
     * @return The sampling supply catalogue item id
     */
    getSamplingSupplyByCode(code: string | null): Observable<GetCatalogueItemIdByCodeResponse> {
        let url_ = this.baseUrl + "/api/sampling-supply/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSamplingSupplyByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSamplingSupplyByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogueItemIdByCodeResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogueItemIdByCodeResponse>;
        }));
    }

    protected processGetSamplingSupplyByCode(response: HttpResponseBase): Observable<GetCatalogueItemIdByCodeResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCatalogueItemIdByCodeResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class JobAccessSimulatorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getSimulatorAccessSummary(simulatorAccessSummaryRequest: SimulatorAccessSummaryRequest): Observable<SimulatorAccessSummaryResponse> {
        let url_ = this.baseUrl + "/api/admin/jobs/access-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(simulatorAccessSummaryRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulatorAccessSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulatorAccessSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulatorAccessSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulatorAccessSummaryResponse>;
        }));
    }

    protected processGetSimulatorAccessSummary(response: HttpResponseBase): Observable<SimulatorAccessSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulatorAccessSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSimulatorJob(jobNumber: number): Observable<SimulatorJobResponse> {
        let url_ = this.baseUrl + "/api/admin/jobs/{jobNumber}";
        if (jobNumber === undefined || jobNumber === null)
            throw new Error("The parameter 'jobNumber' must be defined.");
        url_ = url_.replace("{jobNumber}", encodeURIComponent("" + jobNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSimulatorJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSimulatorJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SimulatorJobResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SimulatorJobResponse>;
        }));
    }

    protected processGetSimulatorJob(response: HttpResponseBase): Observable<SimulatorJobResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SimulatorJobResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Forbidden", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EventsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Log Events
     * @return Events successfully logged
     */
    logEvents(logEventsRequest: LogEventsRequest): Observable<any> {
        let url_ = this.baseUrl + "/api/events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logEventsRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processLogEvents(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Change user password
     * @return Password changed successfully
     */
    changePassword(changePasswordRequest: ChangePasswordRequest): Observable<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/api/auth/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(changePasswordRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePasswordResponse>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ChangePasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("User not authenticated", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data or password requirements", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Authenticate user and retrieve access tokens
     * @return Authentication successful, tokens returned
     */
    login(loginRequest: LoginRequest): Observable<LoginResponse> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(loginRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoginResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoginResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<LoginResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoginResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register a new user account
     * @return User registered successfully
     */
    register(registerRequest: RegisterRequest): Observable<RegisterResponse> {
        let url_ = this.baseUrl + "/api/auth/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data or password requirements", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("User already exists with this email", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resends the verification email to the specified email address.
     * @return The verification email has been sent to the specified email address.
     */
    resendVerificationEmail(resendVerificationEmailRequest: ResendVerificationEmailRequest): Observable<ResendVerificationEmailResponse> {
        let url_ = this.baseUrl + "/api/auth/resend-verification-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resendVerificationEmailRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendVerificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendVerificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResendVerificationEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResendVerificationEmailResponse>;
        }));
    }

    protected processResendVerificationEmail(response: HttpResponseBase): Observable<ResendVerificationEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResendVerificationEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid email address or request data.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Initiates password reset process
     * @return Password reset email has been sent to the specified email address.
     */
    resetPassword(resetPasswordRequest: ResetPasswordRequest): Observable<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid email address or request data.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sets a new password using a reset token
     * @return Password has been set successfully.
     */
    setPassword(setPasswordRequest: SetPasswordRequest): Observable<SetPasswordResponse> {
        let url_ = this.baseUrl + "/api/auth/set-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setPasswordRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetPasswordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetPasswordResponse>;
        }));
    }

    protected processSetPassword(response: HttpResponseBase): Observable<SetPasswordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetPasswordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request data, password requirements not met, or invalid/expired reset token.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verifies an email address using the verification token
     * @return Email successfully verified
     */
    verifyEmail(verifyEmailRequest: VerifyEmailRequest): Observable<VerifyEmailResponse> {
        let url_ = this.baseUrl + "/api/auth/verify-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(verifyEmailRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerifyEmailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerifyEmailResponse>;
        }));
    }

    protected processVerifyEmail(response: HttpResponseBase): Observable<VerifyEmailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerifyEmailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Invalid request or validation errors", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get MyLab configuration
     * @return The configuration for the user
     */
    getConfig(): Observable<GetConfigResponse> {
        let url_ = this.baseUrl + "/api/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetConfigResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetConfigResponse>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<GetConfigResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Response model for AcceptTermsAndConditions endpoint */
export class AcceptTermsAndConditionsResponse implements IAcceptTermsAndConditionsResponse {
    /** Response message */
    message?: string;
    /** Timestamp when terms were accepted (if successful) */
    acceptedAt?: Date | undefined;

    constructor(data?: IAcceptTermsAndConditionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.acceptedAt = _data["acceptedAt"] ? new Date(_data["acceptedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AcceptTermsAndConditionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptTermsAndConditionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["acceptedAt"] = this.acceptedAt ? this.acceptedAt.toISOString() : <any>undefined;
        return data;
    }
}

/** Response model for AcceptTermsAndConditions endpoint */
export interface IAcceptTermsAndConditionsResponse {
    /** Response message */
    message?: string;
    /** Timestamp when terms were accepted (if successful) */
    acceptedAt?: Date | undefined;
}

/** Response model for GetProfile endpoint */
export class GetProfileResponse implements IGetProfileResponse {
    /** Contact ID */
    contactId?: number;
    /** First name */
    firstName?: string;
    /** Last name */
    lastName?: string;
    /** Email address */
    email?: string;
    /** Phone number */
    phone?: string;
    /** Mobile phone number */
    mobile?: string;
    /** Whether user is in use */
    inUse?: boolean;
    /** Contact type */
    contactType?: ProfileContactType;
    /** Contact status */
    contactStatus?: ProfileContactStatus;
    /** Postal address */
    postalAddress?: ProfileAddress | undefined;
    /** Delivery address */
    deliveryAddress?: ProfileAddress | undefined;
    /** Organisation information */
    organisation?: ProfileOrganisation | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean;
    /** Whether portal terms and conditions have been accepted */
    portalTcAccepted?: boolean;
    /** Whether user is staff */
    isStaff?: boolean;

    constructor(data?: IGetProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.inUse = _data["inUse"];
            this.contactType = _data["contactType"];
            this.contactStatus = _data["contactStatus"];
            this.postalAddress = _data["postalAddress"] ? ProfileAddress.fromJS(_data["postalAddress"]) : <any>undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? ProfileAddress.fromJS(_data["deliveryAddress"]) : <any>undefined;
            this.organisation = _data["organisation"] ? ProfileOrganisation.fromJS(_data["organisation"]) : <any>undefined;
            this.hideMyOrders = _data["hideMyOrders"];
            this.portalTcAccepted = _data["portalTcAccepted"];
            this.isStaff = _data["isStaff"];
        }
    }

    static fromJS(data: any): GetProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["inUse"] = this.inUse;
        data["contactType"] = this.contactType;
        data["contactStatus"] = this.contactStatus;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        data["organisation"] = this.organisation ? this.organisation.toJSON() : <any>undefined;
        data["hideMyOrders"] = this.hideMyOrders;
        data["portalTcAccepted"] = this.portalTcAccepted;
        data["isStaff"] = this.isStaff;
        return data;
    }
}

/** Response model for GetProfile endpoint */
export interface IGetProfileResponse {
    /** Contact ID */
    contactId?: number;
    /** First name */
    firstName?: string;
    /** Last name */
    lastName?: string;
    /** Email address */
    email?: string;
    /** Phone number */
    phone?: string;
    /** Mobile phone number */
    mobile?: string;
    /** Whether user is in use */
    inUse?: boolean;
    /** Contact type */
    contactType?: ProfileContactType;
    /** Contact status */
    contactStatus?: ProfileContactStatus;
    /** Postal address */
    postalAddress?: ProfileAddress | undefined;
    /** Delivery address */
    deliveryAddress?: ProfileAddress | undefined;
    /** Organisation information */
    organisation?: ProfileOrganisation | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean;
    /** Whether portal terms and conditions have been accepted */
    portalTcAccepted?: boolean;
    /** Whether user is staff */
    isStaff?: boolean;
}

/** Contact type enumeration for profile */
export enum ProfileContactType {
    CONTACT = 0,
    LEAD = 1,
}

/** Contact status enumeration for profile */
export enum ProfileContactStatus {
    ACTIVE = 1,
    UNCONFIRMED = 2,
    INACTIVE = 3,
    DELETED = 4,
    MARKED_FOR_DELETION = 5,
}

/** Profile address model */
export class ProfileAddress implements IProfileAddress {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId?: number | undefined;

    constructor(data?: IProfileAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.townOrCity = _data["townOrCity"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.recipientInfo = _data["recipientInfo"];
            this.nzPostDpId = _data["nzPostDpId"];
        }
    }

    static fromJS(data: any): ProfileAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["townOrCity"] = this.townOrCity;
        data["country"] = this.country;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["recipientInfo"] = this.recipientInfo;
        data["nzPostDpId"] = this.nzPostDpId;
        return data;
    }
}

/** Profile address model */
export interface IProfileAddress {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId?: number | undefined;
}

/** Profile organisation model */
export class ProfileOrganisation implements IProfileOrganisation {
    /** Organisation name */
    name?: string;
    /** Organisation ID */
    id?: string;

    constructor(data?: IProfileOrganisation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ProfileOrganisation {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileOrganisation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

/** Profile organisation model */
export interface IProfileOrganisation {
    /** Organisation name */
    name?: string;
    /** Organisation ID */
    id?: string;
}

/** Response model for UpdateProfile endpoint */
export class UpdateProfileResponse implements IUpdateProfileResponse {
    /** Contact ID */
    contactId?: number;
    /** First name */
    firstName?: string;
    /** Last name */
    lastName?: string;
    /** Email address */
    email?: string;
    /** Phone number */
    phone?: string;
    /** Mobile phone number */
    mobile?: string;
    /** Whether user is in use */
    inUse?: boolean;
    /** Postal address */
    postalAddress?: UpdateProfileAddressResponse | undefined;
    /** Delivery address */
    deliveryAddress?: UpdateProfileAddressResponse | undefined;
    /** Organisation information */
    organisation?: UpdateProfileOrganisationResponse | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean;
    /** Whether portal terms and conditions have been accepted */
    portalTcAccepted?: boolean;
    /** Whether user is staff */
    isStaff?: boolean;

    constructor(data?: IUpdateProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.inUse = _data["inUse"];
            this.postalAddress = _data["postalAddress"] ? UpdateProfileAddressResponse.fromJS(_data["postalAddress"]) : <any>undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? UpdateProfileAddressResponse.fromJS(_data["deliveryAddress"]) : <any>undefined;
            this.organisation = _data["organisation"] ? UpdateProfileOrganisationResponse.fromJS(_data["organisation"]) : <any>undefined;
            this.hideMyOrders = _data["hideMyOrders"];
            this.portalTcAccepted = _data["portalTcAccepted"];
            this.isStaff = _data["isStaff"];
        }
    }

    static fromJS(data: any): UpdateProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["inUse"] = this.inUse;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        data["organisation"] = this.organisation ? this.organisation.toJSON() : <any>undefined;
        data["hideMyOrders"] = this.hideMyOrders;
        data["portalTcAccepted"] = this.portalTcAccepted;
        data["isStaff"] = this.isStaff;
        return data;
    }
}

/** Response model for UpdateProfile endpoint */
export interface IUpdateProfileResponse {
    /** Contact ID */
    contactId?: number;
    /** First name */
    firstName?: string;
    /** Last name */
    lastName?: string;
    /** Email address */
    email?: string;
    /** Phone number */
    phone?: string;
    /** Mobile phone number */
    mobile?: string;
    /** Whether user is in use */
    inUse?: boolean;
    /** Postal address */
    postalAddress?: UpdateProfileAddressResponse | undefined;
    /** Delivery address */
    deliveryAddress?: UpdateProfileAddressResponse | undefined;
    /** Organisation information */
    organisation?: UpdateProfileOrganisationResponse | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean;
    /** Whether portal terms and conditions have been accepted */
    portalTcAccepted?: boolean;
    /** Whether user is staff */
    isStaff?: boolean;
}

/** Address model for profile update responses */
export class UpdateProfileAddressResponse implements IUpdateProfileAddressResponse {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId?: number | undefined;

    constructor(data?: IUpdateProfileAddressResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.townOrCity = _data["townOrCity"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.recipientInfo = _data["recipientInfo"];
            this.nzPostDpId = _data["nzPostDpId"];
        }
    }

    static fromJS(data: any): UpdateProfileAddressResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileAddressResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["townOrCity"] = this.townOrCity;
        data["country"] = this.country;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["recipientInfo"] = this.recipientInfo;
        data["nzPostDpId"] = this.nzPostDpId;
        return data;
    }
}

/** Address model for profile update responses */
export interface IUpdateProfileAddressResponse {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId?: number | undefined;
}

/** Organisation model for profile update responses */
export class UpdateProfileOrganisationResponse implements IUpdateProfileOrganisationResponse {
    /** Organisation name */
    name?: string;
    /** Organisation ID */
    id?: string;

    constructor(data?: IUpdateProfileOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateProfileOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

/** Organisation model for profile update responses */
export interface IUpdateProfileOrganisationResponse {
    /** Organisation name */
    name?: string;
    /** Organisation ID */
    id?: string;
}

/** the dto used to send an error response to the client */
export class ErrorResponse implements IErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.statusCode = 400;
            this.message = "One or more errors occurred!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : 400;
            this.message = _data["message"] !== undefined ? _data["message"] : "One or more errors occurred!";
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

/** the dto used to send an error response to the client */
export interface IErrorResponse {
    /** the http status code sent to the client. default is 400. */
    statusCode?: number;
    /** the message for the error response */
    message?: string;
    /** the collection of errors for the current context */
    errors?: { [key: string]: string[]; };
}

/** Request model for UpdateProfile endpoint */
export class UpdateProfileRequest implements IUpdateProfileRequest {
    /** Mobile phone number */
    mobile?: string | undefined;
    /** Phone number */
    phone?: string | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean | undefined;
    /** Postal address */
    postalAddress?: UpdateProfileAddressRequest | undefined;
    /** Delivery address */
    deliveryAddress?: UpdateProfileAddressRequest | undefined;

    constructor(data?: IUpdateProfileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobile = _data["mobile"];
            this.phone = _data["phone"];
            this.hideMyOrders = _data["hideMyOrders"];
            this.postalAddress = _data["postalAddress"] ? UpdateProfileAddressRequest.fromJS(_data["postalAddress"]) : <any>undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? UpdateProfileAddressRequest.fromJS(_data["deliveryAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProfileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobile"] = this.mobile;
        data["phone"] = this.phone;
        data["hideMyOrders"] = this.hideMyOrders;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        return data;
    }
}

/** Request model for UpdateProfile endpoint */
export interface IUpdateProfileRequest {
    /** Mobile phone number */
    mobile?: string | undefined;
    /** Phone number */
    phone?: string | undefined;
    /** Whether to hide orders from other users in the organisation */
    hideMyOrders?: boolean | undefined;
    /** Postal address */
    postalAddress?: UpdateProfileAddressRequest | undefined;
    /** Delivery address */
    deliveryAddress?: UpdateProfileAddressRequest | undefined;
}

/** Address model for profile update requests */
export class UpdateProfileAddressRequest implements IUpdateProfileAddressRequest {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId!: number;

    constructor(data?: IUpdateProfileAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.townOrCity = _data["townOrCity"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.recipientInfo = _data["recipientInfo"];
            this.nzPostDpId = _data["nzPostDpId"];
        }
    }

    static fromJS(data: any): UpdateProfileAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["townOrCity"] = this.townOrCity;
        data["country"] = this.country;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["recipientInfo"] = this.recipientInfo;
        data["nzPostDpId"] = this.nzPostDpId;
        return data;
    }
}

/** Address model for profile update requests */
export interface IUpdateProfileAddressRequest {
    /** Address line 1 */
    line1?: string | undefined;
    /** Address line 2 */
    line2?: string | undefined;
    /** Town or city */
    townOrCity?: string | undefined;
    /** Country */
    country?: string | undefined;
    /** Province or state */
    province?: string | undefined;
    /** Post code */
    postCode?: string | undefined;
    /** Recipient information */
    recipientInfo?: string | undefined;
    /** NZ Post delivery point ID */
    nzPostDpId: number;
}

export class OrganisationConfigurationResponse implements IOrganisationConfigurationResponse {
    /** Gets the requested Limbus organisation identifier. */
    limbusOrganisationId?: number;
    organisationName?: string;
    parentLimbusOrganisationId?: number | undefined;
    parentOrganisationName?: string | undefined;
    parentLabSysContactId?: string | undefined;
    inherited?: boolean;
    inheritedFromLimbusOrganisationId?: number | undefined;
    inheritedFromOrganisationName?: string | undefined;
    inheritedFromLabSysContactId?: string | undefined;
    canOrderSamplingSupplies?: boolean;
    canOrderLabTests?: boolean;
    jobsCanCrossBranchShare?: boolean;
    /** Gets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets whether Submitters can view submitted jobs. */
    submitterCanViewJobs?: boolean;
    /** Gets whether Charge To contacts can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets whether Charge To contacts can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets whether Charge To contacts can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    inheritedCanOrderSamplingSupplies?: boolean;
    inheritedCanOrderLabTests?: boolean;
    inheritedJobsCanCrossBranchShare?: boolean;
    /** Gets the inherited/default Primary-affiliate job permission. */
    inheritedPrimaryAffiliateCanViewJobs?: boolean;
    /** Gets the inherited/default Primary-affiliate result permission. */
    inheritedPrimaryAffiliateCanViewResults?: boolean;
    /** Gets the inherited/default Submitter job permission. */
    inheritedSubmitterCanViewJobs?: boolean;
    /** Gets the inherited/default direct Charge To job permission. */
    inheritedChargeToCanViewJobs?: boolean;
    /** Gets the inherited/default direct Charge To result permission. */
    inheritedChargeToCanViewResults?: boolean;
    /** Gets the inherited/default direct Charge To invoice permission. */
    inheritedChargeToCanViewInvoices?: boolean;
    /** Gets the inherited/default Charge To-affiliate job permission. */
    inheritedChargeToAffiliateCanViewJobs?: boolean;
    /** Gets the inherited/default Charge To-affiliate result permission. */
    inheritedChargeToAffiliateCanViewResults?: boolean;
    /** Gets the inherited/default Charge To-affiliate invoice permission. */
    inheritedChargeToAffiliateCanViewInvoices?: boolean;
    /** Gets the optimistic concurrency token for the current stored row. */
    lastUpdatedAt?: Date | undefined;
    /** Gets the actor who last updated the current stored row. */
    lastUpdatedBy?: string | undefined;

    constructor(data?: IOrganisationConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limbusOrganisationId = _data["limbusOrganisationId"];
            this.organisationName = _data["organisationName"];
            this.parentLimbusOrganisationId = _data["parentLimbusOrganisationId"];
            this.parentOrganisationName = _data["parentOrganisationName"];
            this.parentLabSysContactId = _data["parentLabSysContactId"];
            this.inherited = _data["inherited"];
            this.inheritedFromLimbusOrganisationId = _data["inheritedFromLimbusOrganisationId"];
            this.inheritedFromOrganisationName = _data["inheritedFromOrganisationName"];
            this.inheritedFromLabSysContactId = _data["inheritedFromLabSysContactId"];
            this.canOrderSamplingSupplies = _data["canOrderSamplingSupplies"];
            this.canOrderLabTests = _data["canOrderLabTests"];
            this.jobsCanCrossBranchShare = _data["jobsCanCrossBranchShare"];
            this.primaryAffiliateCanViewJobs = _data["primaryAffiliateCanViewJobs"];
            this.primaryAffiliateCanViewResults = _data["primaryAffiliateCanViewResults"];
            this.submitterCanViewJobs = _data["submitterCanViewJobs"];
            this.chargeToCanViewJobs = _data["chargeToCanViewJobs"];
            this.chargeToCanViewResults = _data["chargeToCanViewResults"];
            this.chargeToCanViewInvoices = _data["chargeToCanViewInvoices"];
            this.chargeToAffiliateCanViewJobs = _data["chargeToAffiliateCanViewJobs"];
            this.chargeToAffiliateCanViewResults = _data["chargeToAffiliateCanViewResults"];
            this.chargeToAffiliateCanViewInvoices = _data["chargeToAffiliateCanViewInvoices"];
            this.inheritedCanOrderSamplingSupplies = _data["inheritedCanOrderSamplingSupplies"];
            this.inheritedCanOrderLabTests = _data["inheritedCanOrderLabTests"];
            this.inheritedJobsCanCrossBranchShare = _data["inheritedJobsCanCrossBranchShare"];
            this.inheritedPrimaryAffiliateCanViewJobs = _data["inheritedPrimaryAffiliateCanViewJobs"];
            this.inheritedPrimaryAffiliateCanViewResults = _data["inheritedPrimaryAffiliateCanViewResults"];
            this.inheritedSubmitterCanViewJobs = _data["inheritedSubmitterCanViewJobs"];
            this.inheritedChargeToCanViewJobs = _data["inheritedChargeToCanViewJobs"];
            this.inheritedChargeToCanViewResults = _data["inheritedChargeToCanViewResults"];
            this.inheritedChargeToCanViewInvoices = _data["inheritedChargeToCanViewInvoices"];
            this.inheritedChargeToAffiliateCanViewJobs = _data["inheritedChargeToAffiliateCanViewJobs"];
            this.inheritedChargeToAffiliateCanViewResults = _data["inheritedChargeToAffiliateCanViewResults"];
            this.inheritedChargeToAffiliateCanViewInvoices = _data["inheritedChargeToAffiliateCanViewInvoices"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
        }
    }

    static fromJS(data: any): OrganisationConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limbusOrganisationId"] = this.limbusOrganisationId;
        data["organisationName"] = this.organisationName;
        data["parentLimbusOrganisationId"] = this.parentLimbusOrganisationId;
        data["parentOrganisationName"] = this.parentOrganisationName;
        data["parentLabSysContactId"] = this.parentLabSysContactId;
        data["inherited"] = this.inherited;
        data["inheritedFromLimbusOrganisationId"] = this.inheritedFromLimbusOrganisationId;
        data["inheritedFromOrganisationName"] = this.inheritedFromOrganisationName;
        data["inheritedFromLabSysContactId"] = this.inheritedFromLabSysContactId;
        data["canOrderSamplingSupplies"] = this.canOrderSamplingSupplies;
        data["canOrderLabTests"] = this.canOrderLabTests;
        data["jobsCanCrossBranchShare"] = this.jobsCanCrossBranchShare;
        data["primaryAffiliateCanViewJobs"] = this.primaryAffiliateCanViewJobs;
        data["primaryAffiliateCanViewResults"] = this.primaryAffiliateCanViewResults;
        data["submitterCanViewJobs"] = this.submitterCanViewJobs;
        data["chargeToCanViewJobs"] = this.chargeToCanViewJobs;
        data["chargeToCanViewResults"] = this.chargeToCanViewResults;
        data["chargeToCanViewInvoices"] = this.chargeToCanViewInvoices;
        data["chargeToAffiliateCanViewJobs"] = this.chargeToAffiliateCanViewJobs;
        data["chargeToAffiliateCanViewResults"] = this.chargeToAffiliateCanViewResults;
        data["chargeToAffiliateCanViewInvoices"] = this.chargeToAffiliateCanViewInvoices;
        data["inheritedCanOrderSamplingSupplies"] = this.inheritedCanOrderSamplingSupplies;
        data["inheritedCanOrderLabTests"] = this.inheritedCanOrderLabTests;
        data["inheritedJobsCanCrossBranchShare"] = this.inheritedJobsCanCrossBranchShare;
        data["inheritedPrimaryAffiliateCanViewJobs"] = this.inheritedPrimaryAffiliateCanViewJobs;
        data["inheritedPrimaryAffiliateCanViewResults"] = this.inheritedPrimaryAffiliateCanViewResults;
        data["inheritedSubmitterCanViewJobs"] = this.inheritedSubmitterCanViewJobs;
        data["inheritedChargeToCanViewJobs"] = this.inheritedChargeToCanViewJobs;
        data["inheritedChargeToCanViewResults"] = this.inheritedChargeToCanViewResults;
        data["inheritedChargeToCanViewInvoices"] = this.inheritedChargeToCanViewInvoices;
        data["inheritedChargeToAffiliateCanViewJobs"] = this.inheritedChargeToAffiliateCanViewJobs;
        data["inheritedChargeToAffiliateCanViewResults"] = this.inheritedChargeToAffiliateCanViewResults;
        data["inheritedChargeToAffiliateCanViewInvoices"] = this.inheritedChargeToAffiliateCanViewInvoices;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        return data;
    }
}

export interface IOrganisationConfigurationResponse {
    /** Gets the requested Limbus organisation identifier. */
    limbusOrganisationId?: number;
    organisationName?: string;
    parentLimbusOrganisationId?: number | undefined;
    parentOrganisationName?: string | undefined;
    parentLabSysContactId?: string | undefined;
    inherited?: boolean;
    inheritedFromLimbusOrganisationId?: number | undefined;
    inheritedFromOrganisationName?: string | undefined;
    inheritedFromLabSysContactId?: string | undefined;
    canOrderSamplingSupplies?: boolean;
    canOrderLabTests?: boolean;
    jobsCanCrossBranchShare?: boolean;
    /** Gets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets whether Submitters can view submitted jobs. */
    submitterCanViewJobs?: boolean;
    /** Gets whether Charge To contacts can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets whether Charge To contacts can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets whether Charge To contacts can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    inheritedCanOrderSamplingSupplies?: boolean;
    inheritedCanOrderLabTests?: boolean;
    inheritedJobsCanCrossBranchShare?: boolean;
    /** Gets the inherited/default Primary-affiliate job permission. */
    inheritedPrimaryAffiliateCanViewJobs?: boolean;
    /** Gets the inherited/default Primary-affiliate result permission. */
    inheritedPrimaryAffiliateCanViewResults?: boolean;
    /** Gets the inherited/default Submitter job permission. */
    inheritedSubmitterCanViewJobs?: boolean;
    /** Gets the inherited/default direct Charge To job permission. */
    inheritedChargeToCanViewJobs?: boolean;
    /** Gets the inherited/default direct Charge To result permission. */
    inheritedChargeToCanViewResults?: boolean;
    /** Gets the inherited/default direct Charge To invoice permission. */
    inheritedChargeToCanViewInvoices?: boolean;
    /** Gets the inherited/default Charge To-affiliate job permission. */
    inheritedChargeToAffiliateCanViewJobs?: boolean;
    /** Gets the inherited/default Charge To-affiliate result permission. */
    inheritedChargeToAffiliateCanViewResults?: boolean;
    /** Gets the inherited/default Charge To-affiliate invoice permission. */
    inheritedChargeToAffiliateCanViewInvoices?: boolean;
    /** Gets the optimistic concurrency token for the current stored row. */
    lastUpdatedAt?: Date | undefined;
    /** Gets the actor who last updated the current stored row. */
    lastUpdatedBy?: string | undefined;
}

export class GetOrganisationConfigurationRequest implements IGetOrganisationConfigurationRequest {

    constructor(data?: IGetOrganisationConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrganisationConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrganisationConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrganisationConfigurationRequest {
}

/** Separates the authoritative route identifier from the flat JSON request body so mismatches can be rejected. */
export class UpdateOrganisationConfigurationEndpointRequest implements IUpdateOrganisationConfigurationEndpointRequest {
    /** Gets or sets the complete flat JSON configuration body. */
    configuration!: UpdateOrganisationConfigurationRequest;

    constructor(data?: IUpdateOrganisationConfigurationEndpointRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configuration = new UpdateOrganisationConfigurationRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.configuration = _data["configuration"] ? UpdateOrganisationConfigurationRequest.fromJS(_data["configuration"]) : new UpdateOrganisationConfigurationRequest();
        }
    }

    static fromJS(data: any): UpdateOrganisationConfigurationEndpointRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganisationConfigurationEndpointRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

/** Separates the authoritative route identifier from the flat JSON request body so mismatches can be rejected. */
export interface IUpdateOrganisationConfigurationEndpointRequest {
    /** Gets or sets the complete flat JSON configuration body. */
    configuration: UpdateOrganisationConfigurationRequest;
}

export class UpdateOrganisationConfigurationRequest implements IUpdateOrganisationConfigurationRequest {
    /** Gets or sets the target Limbus organisation identifier. */
    limbusOrganisationId?: number;
    /** Gets or sets whether the organisation uses inherited/default effective values. */
    inherited?: boolean;
    /** Gets or sets whether sampling supplies can be ordered. */
    canOrderSamplingSupplies?: boolean;
    /** Gets or sets whether lab tests can be ordered. */
    canOrderLabTests?: boolean;
    /** Gets or sets whether jobs can be shared across branches. */
    jobsCanCrossBranchShare?: boolean;
    /** Gets or sets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets or sets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets or sets whether Submitters can view submitted jobs. */
    submitterCanViewJobs?: boolean;
    /** Gets or sets whether Charge To contacts can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets or sets whether Charge To contacts can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets or sets whether Charge To contacts can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets or sets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets or sets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets or sets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    /** Gets or sets the last-read timestamp used to reject stale writes. */
    lastUpdatedAt?: Date | undefined;
    /** Gets or sets the authenticated human actor supplied by MyLab Admin. */
    updatedBy!: string;

    constructor(data?: IUpdateOrganisationConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limbusOrganisationId = _data["limbusOrganisationId"];
            this.inherited = _data["inherited"];
            this.canOrderSamplingSupplies = _data["canOrderSamplingSupplies"];
            this.canOrderLabTests = _data["canOrderLabTests"];
            this.jobsCanCrossBranchShare = _data["jobsCanCrossBranchShare"];
            this.primaryAffiliateCanViewJobs = _data["primaryAffiliateCanViewJobs"];
            this.primaryAffiliateCanViewResults = _data["primaryAffiliateCanViewResults"];
            this.submitterCanViewJobs = _data["submitterCanViewJobs"];
            this.chargeToCanViewJobs = _data["chargeToCanViewJobs"];
            this.chargeToCanViewResults = _data["chargeToCanViewResults"];
            this.chargeToCanViewInvoices = _data["chargeToCanViewInvoices"];
            this.chargeToAffiliateCanViewJobs = _data["chargeToAffiliateCanViewJobs"];
            this.chargeToAffiliateCanViewResults = _data["chargeToAffiliateCanViewResults"];
            this.chargeToAffiliateCanViewInvoices = _data["chargeToAffiliateCanViewInvoices"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
        }
    }

    static fromJS(data: any): UpdateOrganisationConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganisationConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limbusOrganisationId"] = this.limbusOrganisationId;
        data["inherited"] = this.inherited;
        data["canOrderSamplingSupplies"] = this.canOrderSamplingSupplies;
        data["canOrderLabTests"] = this.canOrderLabTests;
        data["jobsCanCrossBranchShare"] = this.jobsCanCrossBranchShare;
        data["primaryAffiliateCanViewJobs"] = this.primaryAffiliateCanViewJobs;
        data["primaryAffiliateCanViewResults"] = this.primaryAffiliateCanViewResults;
        data["submitterCanViewJobs"] = this.submitterCanViewJobs;
        data["chargeToCanViewJobs"] = this.chargeToCanViewJobs;
        data["chargeToCanViewResults"] = this.chargeToCanViewResults;
        data["chargeToCanViewInvoices"] = this.chargeToCanViewInvoices;
        data["chargeToAffiliateCanViewJobs"] = this.chargeToAffiliateCanViewJobs;
        data["chargeToAffiliateCanViewResults"] = this.chargeToAffiliateCanViewResults;
        data["chargeToAffiliateCanViewInvoices"] = this.chargeToAffiliateCanViewInvoices;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        return data;
    }
}

export interface IUpdateOrganisationConfigurationRequest {
    /** Gets or sets the target Limbus organisation identifier. */
    limbusOrganisationId?: number;
    /** Gets or sets whether the organisation uses inherited/default effective values. */
    inherited?: boolean;
    /** Gets or sets whether sampling supplies can be ordered. */
    canOrderSamplingSupplies?: boolean;
    /** Gets or sets whether lab tests can be ordered. */
    canOrderLabTests?: boolean;
    /** Gets or sets whether jobs can be shared across branches. */
    jobsCanCrossBranchShare?: boolean;
    /** Gets or sets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets or sets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets or sets whether Submitters can view submitted jobs. */
    submitterCanViewJobs?: boolean;
    /** Gets or sets whether Charge To contacts can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets or sets whether Charge To contacts can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets or sets whether Charge To contacts can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets or sets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets or sets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets or sets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    /** Gets or sets the last-read timestamp used to reject stale writes. */
    lastUpdatedAt?: Date | undefined;
    /** Gets or sets the authenticated human actor supplied by MyLab Admin. */
    updatedBy: string;
}

/** Represents one sampling or container supply line in the existing order-history contract. */
export class OrderSamplingItem implements IOrderSamplingItem {
    /** The catalogue item identifier resolved from the source item. */
    catalogueItemId?: number;
    /** The customer-facing catalogue name, when mapped. */
    name?: string | undefined;
    /** The ordered quantity. */
    quantity?: number;
    /** The listed unit price captured on the order line. */
    unitPrice?: number;
    /** The listed unit price multiplied by quantity. */
    totalPrice?: number;

    constructor(data?: IOrderSamplingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): OrderSamplingItem {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSamplingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

/** Represents one sampling or container supply line in the existing order-history contract. */
export interface IOrderSamplingItem {
    /** The catalogue item identifier resolved from the source item. */
    catalogueItemId?: number;
    /** The customer-facing catalogue name, when mapped. */
    name?: string | undefined;
    /** The ordered quantity. */
    quantity?: number;
    /** The listed unit price captured on the order line. */
    unitPrice?: number;
    /** The listed unit price multiplied by quantity. */
    totalPrice?: number;
}

/** Contains the comma-separated work-item route and compatible legacy query parameter. */
export class GetSamplingItemsRequest implements IGetSamplingItemsRequest {

    constructor(data?: IGetSamplingItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSamplingItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSamplingItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Contains the comma-separated work-item route and compatible legacy query parameter. */
export interface IGetSamplingItemsRequest {
}

/** Contains an authorised work item's detail, samples, and viewer capability hints. */
export class GetOrderDetailResponse implements IGetOrderDetailResponse {
    /** Gets or sets the browser-compatible work-item detail. */
    order?: OrderDetail;
    /** Gets or sets analytical samples with their requested tests. */
    samples?: OrderSampleDetail[];
    /** Gets or sets sampling and container supply lines for the order. */
    samplingItems?: OrderSamplingItem[];
    /** Gets or sets whether the viewer may open result operations. */
    canViewResults?: boolean;
    /** Gets or sets whether the viewer may open invoice operations. */
    canViewInvoices?: boolean;

    constructor(data?: IGetOrderDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? OrderDetail.fromJS(_data["order"]) : <any>undefined;
            if (Array.isArray(_data["samples"])) {
                this.samples = [] as any;
                for (let item of _data["samples"])
                    this.samples!.push(OrderSampleDetail.fromJS(item));
            }
            if (Array.isArray(_data["samplingItems"])) {
                this.samplingItems = [] as any;
                for (let item of _data["samplingItems"])
                    this.samplingItems!.push(OrderSamplingItem.fromJS(item));
            }
            this.canViewResults = _data["canViewResults"];
            this.canViewInvoices = _data["canViewInvoices"];
        }
    }

    static fromJS(data: any): GetOrderDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        if (Array.isArray(this.samples)) {
            data["samples"] = [];
            for (let item of this.samples)
                data["samples"].push(item.toJSON());
        }
        if (Array.isArray(this.samplingItems)) {
            data["samplingItems"] = [];
            for (let item of this.samplingItems)
                data["samplingItems"].push(item.toJSON());
        }
        data["canViewResults"] = this.canViewResults;
        data["canViewInvoices"] = this.canViewInvoices;
        return data;
    }
}

/** Contains an authorised work item's detail, samples, and viewer capability hints. */
export interface IGetOrderDetailResponse {
    /** Gets or sets the browser-compatible work-item detail. */
    order?: OrderDetail;
    /** Gets or sets analytical samples with their requested tests. */
    samples?: OrderSampleDetail[];
    /** Gets or sets sampling and container supply lines for the order. */
    samplingItems?: OrderSamplingItem[];
    /** Gets or sets whether the viewer may open result operations. */
    canViewResults?: boolean;
    /** Gets or sets whether the viewer may open invoice operations. */
    canViewInvoices?: boolean;
}

/** Represents the existing browser order-detail contract. */
export class OrderDetail implements IOrderDetail {
    orderId?: number | undefined;
    jobNumber?: number | undefined;
    jobType?: OrderHistoryJobType;
    status?: OrderHistoryStatus;
    orderDate?: Date;
    targetDate?: Date | undefined;
    finishedDate?: Date | undefined;
    receivedDate?: Date | undefined;
    clientReference?: string | undefined;
    additionalReference?: string | undefined;
    quoteNumber?: string | undefined;
    clientOrderNumber?: string | undefined;
    client?: OrderDetailContact | undefined;
    primaryContact?: OrderDetailContact | undefined;
    submitter?: OrderDetailContact | undefined;
    charge?: OrderDetailContact | undefined;
    deliveryAddress?: OrderDetailAddress | undefined;
    clientPickup?: boolean;
    consignments?: OrderDetailConsignment[];
    orderReferences?: OrderDetailReference[];
    hasChainOfCustodyForm?: boolean;
    hasInvoice?: boolean;
    jobSourceName?: string | undefined;
    qowqed?: boolean;
    holding?: boolean;
    holdingReports?: boolean;
    orderPriority?: number | undefined;

    constructor(data?: IOrderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.jobNumber = _data["jobNumber"];
            this.jobType = _data["jobType"];
            this.status = _data["status"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.finishedDate = _data["finishedDate"] ? new Date(_data["finishedDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.clientReference = _data["clientReference"];
            this.additionalReference = _data["additionalReference"];
            this.quoteNumber = _data["quoteNumber"];
            this.clientOrderNumber = _data["clientOrderNumber"];
            this.client = _data["client"] ? OrderDetailContact.fromJS(_data["client"]) : <any>undefined;
            this.primaryContact = _data["primaryContact"] ? OrderDetailContact.fromJS(_data["primaryContact"]) : <any>undefined;
            this.submitter = _data["submitter"] ? OrderDetailContact.fromJS(_data["submitter"]) : <any>undefined;
            this.charge = _data["charge"] ? OrderDetailContact.fromJS(_data["charge"]) : <any>undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? OrderDetailAddress.fromJS(_data["deliveryAddress"]) : <any>undefined;
            this.clientPickup = _data["clientPickup"];
            if (Array.isArray(_data["consignments"])) {
                this.consignments = [] as any;
                for (let item of _data["consignments"])
                    this.consignments!.push(OrderDetailConsignment.fromJS(item));
            }
            if (Array.isArray(_data["orderReferences"])) {
                this.orderReferences = [] as any;
                for (let item of _data["orderReferences"])
                    this.orderReferences!.push(OrderDetailReference.fromJS(item));
            }
            this.hasChainOfCustodyForm = _data["hasChainOfCustodyForm"];
            this.hasInvoice = _data["hasInvoice"];
            this.jobSourceName = _data["jobSourceName"];
            this.qowqed = _data["qowqed"];
            this.holding = _data["holding"];
            this.holdingReports = _data["holdingReports"];
            this.orderPriority = _data["orderPriority"];
        }
    }

    static fromJS(data: any): OrderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["jobNumber"] = this.jobNumber;
        data["jobType"] = this.jobType;
        data["status"] = this.status;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["finishedDate"] = this.finishedDate ? this.finishedDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["clientReference"] = this.clientReference;
        data["additionalReference"] = this.additionalReference;
        data["quoteNumber"] = this.quoteNumber;
        data["clientOrderNumber"] = this.clientOrderNumber;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["primaryContact"] = this.primaryContact ? this.primaryContact.toJSON() : <any>undefined;
        data["submitter"] = this.submitter ? this.submitter.toJSON() : <any>undefined;
        data["charge"] = this.charge ? this.charge.toJSON() : <any>undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        data["clientPickup"] = this.clientPickup;
        if (Array.isArray(this.consignments)) {
            data["consignments"] = [];
            for (let item of this.consignments)
                data["consignments"].push(item.toJSON());
        }
        if (Array.isArray(this.orderReferences)) {
            data["orderReferences"] = [];
            for (let item of this.orderReferences)
                data["orderReferences"].push(item.toJSON());
        }
        data["hasChainOfCustodyForm"] = this.hasChainOfCustodyForm;
        data["hasInvoice"] = this.hasInvoice;
        data["jobSourceName"] = this.jobSourceName;
        data["qowqed"] = this.qowqed;
        data["holding"] = this.holding;
        data["holdingReports"] = this.holdingReports;
        data["orderPriority"] = this.orderPriority;
        return data;
    }
}

/** Represents the existing browser order-detail contract. */
export interface IOrderDetail {
    orderId?: number | undefined;
    jobNumber?: number | undefined;
    jobType?: OrderHistoryJobType;
    status?: OrderHistoryStatus;
    orderDate?: Date;
    targetDate?: Date | undefined;
    finishedDate?: Date | undefined;
    receivedDate?: Date | undefined;
    clientReference?: string | undefined;
    additionalReference?: string | undefined;
    quoteNumber?: string | undefined;
    clientOrderNumber?: string | undefined;
    client?: OrderDetailContact | undefined;
    primaryContact?: OrderDetailContact | undefined;
    submitter?: OrderDetailContact | undefined;
    charge?: OrderDetailContact | undefined;
    deliveryAddress?: OrderDetailAddress | undefined;
    clientPickup?: boolean;
    consignments?: OrderDetailConsignment[];
    orderReferences?: OrderDetailReference[];
    hasChainOfCustodyForm?: boolean;
    hasInvoice?: boolean;
    jobSourceName?: string | undefined;
    qowqed?: boolean;
    holding?: boolean;
    holdingReports?: boolean;
    orderPriority?: number | undefined;
}

/** Identifies the browser-visible order type values retained from Aggregator. */
export enum OrderHistoryJobType {
    AnalyticalTest = 1,
    SamplingSupplies = 2,
}

/** Identifies the browser-visible order status values retained from Aggregator. */
export enum OrderHistoryStatus {
    PreRegistered = 0,
    Received = 1,
    Registered = 2,
    Processing = 3,
    WaitingForSigning = 4,
    Cancelled = 5,
    Finished = 6,
}

/** Represents a role holder displayed on order detail. */
export class OrderDetailContact implements IOrderDetailContact {
    name?: string | undefined;
    postalAddress?: OrderDetailAddress | undefined;
    deliveryAddress?: OrderDetailAddress | undefined;

    constructor(data?: IOrderDetailContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.postalAddress = _data["postalAddress"] ? OrderDetailAddress.fromJS(_data["postalAddress"]) : <any>undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? OrderDetailAddress.fromJS(_data["deliveryAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderDetailContact {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents a role holder displayed on order detail. */
export interface IOrderDetailContact {
    name?: string | undefined;
    postalAddress?: OrderDetailAddress | undefined;
    deliveryAddress?: OrderDetailAddress | undefined;
}

/** Represents a browser-compatible postal or delivery address. */
export class OrderDetailAddress implements IOrderDetailAddress {
    recipientInfo?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    townOrCity?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;

    constructor(data?: IOrderDetailAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientInfo = _data["recipientInfo"];
            this.line1 = _data["line1"];
            this.line2 = _data["line2"];
            this.townOrCity = _data["townOrCity"];
            this.province = _data["province"];
            this.postCode = _data["postCode"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): OrderDetailAddress {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientInfo"] = this.recipientInfo;
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["townOrCity"] = this.townOrCity;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        return data;
    }
}

/** Represents a browser-compatible postal or delivery address. */
export interface IOrderDetailAddress {
    recipientInfo?: string | undefined;
    line1?: string | undefined;
    line2?: string | undefined;
    townOrCity?: string | undefined;
    province?: string | undefined;
    postCode?: string | undefined;
    country?: string | undefined;
}

/** Represents a dispatch consignment attached to the detail response. */
export class OrderDetailConsignment implements IOrderDetailConsignment {
    id?: number;
    courier?: string | undefined;
    addressId?: number;
    addressName?: string | undefined;
    costCenterId?: number | undefined;
    saturdayDelivery?: boolean;
    signatureRequired?: boolean;
    courierConsignmentId?: string | undefined;
    trackingUrl?: string | undefined;
    attentionTo?: string | undefined;
    email?: string | undefined;
    reference?: string | undefined;
    deliveryInstructions?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastUpdatedBy?: string | undefined;
    lastUpdatedAt?: Date;
    splitCostCentre?: string | undefined;

    constructor(data?: IOrderDetailConsignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.courier = _data["courier"];
            this.addressId = _data["addressId"];
            this.addressName = _data["addressName"];
            this.costCenterId = _data["costCenterId"];
            this.saturdayDelivery = _data["saturdayDelivery"];
            this.signatureRequired = _data["signatureRequired"];
            this.courierConsignmentId = _data["courierConsignmentId"];
            this.trackingUrl = _data["trackingUrl"];
            this.attentionTo = _data["attentionTo"];
            this.email = _data["email"];
            this.reference = _data["reference"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.splitCostCentre = _data["splitCostCentre"];
        }
    }

    static fromJS(data: any): OrderDetailConsignment {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailConsignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["courier"] = this.courier;
        data["addressId"] = this.addressId;
        data["addressName"] = this.addressName;
        data["costCenterId"] = this.costCenterId;
        data["saturdayDelivery"] = this.saturdayDelivery;
        data["signatureRequired"] = this.signatureRequired;
        data["courierConsignmentId"] = this.courierConsignmentId;
        data["trackingUrl"] = this.trackingUrl;
        data["attentionTo"] = this.attentionTo;
        data["email"] = this.email;
        data["reference"] = this.reference;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["splitCostCentre"] = this.splitCostCentre;
        return data;
    }
}

/** Represents a dispatch consignment attached to the detail response. */
export interface IOrderDetailConsignment {
    id?: number;
    courier?: string | undefined;
    addressId?: number;
    addressName?: string | undefined;
    costCenterId?: number | undefined;
    saturdayDelivery?: boolean;
    signatureRequired?: boolean;
    courierConsignmentId?: string | undefined;
    trackingUrl?: string | undefined;
    attentionTo?: string | undefined;
    email?: string | undefined;
    reference?: string | undefined;
    deliveryInstructions?: string | undefined;
    createdBy?: string | undefined;
    createdAt?: Date;
    lastUpdatedBy?: string | undefined;
    lastUpdatedAt?: Date;
    splitCostCentre?: string | undefined;
}

/** Represents an external order reference. */
export class OrderDetailReference implements IOrderDetailReference {
    name?: string;
    value?: string;

    constructor(data?: IOrderDetailReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OrderDetailReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrderDetailReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

/** Represents an external order reference. */
export interface IOrderDetailReference {
    name?: string;
    value?: string;
}

/** Represents one LabSys job sample and its requested tests. */
export class OrderSampleDetail implements IOrderSampleDetail {
    sampleId?: number;
    jobNumber?: number;
    sampleNumber?: number;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    requestedTests?: RequestedTestDetail[];

    constructor(data?: IOrderSampleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleId = _data["sampleId"];
            this.jobNumber = _data["jobNumber"];
            this.sampleNumber = _data["sampleNumber"];
            this.name = _data["name"];
            this.clientSampleId = _data["clientSampleId"];
            if (Array.isArray(_data["requestedTests"])) {
                this.requestedTests = [] as any;
                for (let item of _data["requestedTests"])
                    this.requestedTests!.push(RequestedTestDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderSampleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleId"] = this.sampleId;
        data["jobNumber"] = this.jobNumber;
        data["sampleNumber"] = this.sampleNumber;
        data["name"] = this.name;
        data["clientSampleId"] = this.clientSampleId;
        if (Array.isArray(this.requestedTests)) {
            data["requestedTests"] = [];
            for (let item of this.requestedTests)
                data["requestedTests"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents one LabSys job sample and its requested tests. */
export interface IOrderSampleDetail {
    sampleId?: number;
    jobNumber?: number;
    sampleNumber?: number;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    requestedTests?: RequestedTestDetail[];
}

/** Represents one requested LabSys analytical activity. */
export class RequestedTestDetail implements IRequestedTestDetail {
    activityId?: number;
    status?: string;
    code?: string;
    name?: string;
    dateTimeFinished?: Date | undefined;

    constructor(data?: IRequestedTestDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.status = _data["status"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.dateTimeFinished = _data["dateTimeFinished"] ? new Date(_data["dateTimeFinished"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestedTestDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RequestedTestDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        data["code"] = this.code;
        data["name"] = this.name;
        data["dateTimeFinished"] = this.dateTimeFinished ? this.dateTimeFinished.toISOString() : <any>undefined;
        return data;
    }
}

/** Represents one requested LabSys analytical activity. */
export interface IRequestedTestDetail {
    activityId?: number;
    status?: string;
    code?: string;
    name?: string;
    dateTimeFinished?: Date | undefined;
}

/** Provides the comma-separated route identifier and compatible query parameters. */
export class GetOrderDetailRequest implements IGetOrderDetailRequest {

    constructor(data?: IGetOrderDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Provides the comma-separated route identifier and compatible query parameters. */
export interface IGetOrderDetailRequest {
}

/** Wraps a newly identified preview batch without treating its identifier as authorization. */
export class GetOrderPreviewsResponse implements IGetOrderPreviewsResponse {
    /** Gets the opaque identifier for this preview response. */
    responseId?: string;
    /** Gets the authorised previews. */
    orderPreviews?: OrderPreview[];

    constructor(data?: IGetOrderPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseId = _data["responseId"];
            if (Array.isArray(_data["orderPreviews"])) {
                this.orderPreviews = [] as any;
                for (let item of _data["orderPreviews"])
                    this.orderPreviews!.push(OrderPreview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrderPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseId"] = this.responseId;
        if (Array.isArray(this.orderPreviews)) {
            data["orderPreviews"] = [];
            for (let item of this.orderPreviews)
                data["orderPreviews"].push(item.toJSON());
        }
        return data;
    }
}

/** Wraps a newly identified preview batch without treating its identifier as authorization. */
export interface IGetOrderPreviewsResponse {
    /** Gets the opaque identifier for this preview response. */
    responseId?: string;
    /** Gets the authorised previews. */
    orderPreviews?: OrderPreview[];
}

/** Represents the lightweight identifier and date used by the existing batched grid flow. */
export class OrderPreview implements IOrderPreview {
    /** Gets the Limbus order identifier when one exists. */
    orderId?: number | undefined;
    /** Gets the LabSys job number when one exists. */
    labSysJobNumber?: number | undefined;
    /** Gets the displayed order date. */
    orderDate?: Date;

    constructor(data?: IOrderPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.labSysJobNumber = _data["labSysJobNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderPreview {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["labSysJobNumber"] = this.labSysJobNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        return data;
    }
}

/** Represents the lightweight identifier and date used by the existing batched grid flow. */
export interface IOrderPreview {
    /** Gets the Limbus order identifier when one exists. */
    orderId?: number | undefined;
    /** Gets the LabSys job number when one exists. */
    labSysJobNumber?: number | undefined;
    /** Gets the displayed order date. */
    orderDate?: Date;
}

/** Controls whether preview candidate discovery includes configured relationships. */
export class GetOrderPreviewsRequest implements IGetOrderPreviewsRequest {

    constructor(data?: IGetOrderPreviewsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderPreviewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderPreviewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Controls whether preview candidate discovery includes configured relationships. */
export interface IGetOrderPreviewsRequest {
}

/** Wraps authorised My Jobs rows using the existing browser response property. */
export class GetOrdersResponse implements IGetOrdersResponse {
    /** Gets the authorised rows. */
    orders?: OrderHistorySummary[];

    constructor(data?: IGetOrdersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [] as any;
                for (let item of _data["orders"])
                    this.orders!.push(OrderHistorySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrdersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}

/** Wraps authorised My Jobs rows using the existing browser response property. */
export interface IGetOrdersResponse {
    /** Gets the authorised rows. */
    orders?: OrderHistorySummary[];
}

/** Represents one authorised row in the existing My Jobs browser contract. */
export class OrderHistorySummary implements IOrderHistorySummary {
    /** Gets the Limbus order identifier when one exists. */
    orderId?: number | undefined;
    /** Gets the LabSys job number when the work item is a job. */
    jobNumber?: number | undefined;
    /** Gets the browser-compatible job type. */
    jobType?: OrderHistoryJobType;
    /** Gets the browser-compatible status. */
    status?: OrderHistoryStatus;
    /** Gets the displayed order date. */
    orderDate?: Date;
    /** Gets the target date when projected. */
    targetDate?: Date | undefined;
    /** Gets the received date when projected. */
    receivedDate?: Date | undefined;
    /** Gets the customer reference. */
    clientReference?: string | undefined;
    /** Gets the quote number. */
    quoteNumber?: string | undefined;
    /** Gets the customer order number. */
    clientOrderNumber?: string | undefined;
    /** Gets the primary LabSys contact identifier. */
    contactId?: number;
    /** Gets the primary role display name. */
    contactName?: string | undefined;
    /** Gets the client organisation identifier when projected. */
    accountId?: number | undefined;
    /** Gets the client display name. */
    clientName?: string | undefined;
    /** Gets the Charge To display name. */
    chargeToName?: string | undefined;
    /** Gets the source name. */
    jobSourceName?: string | undefined;
    /** Gets whether quality control is waiting for query entry or disposition. */
    qowqed?: boolean;
    /** Gets whether the job is on hold. */
    holding?: boolean;
    /** Gets whether reports are on hold. */
    holdingReports?: boolean;
    /** Gets the completion percentage when projected. */
    percentageComplete?: number | undefined;
    /** Gets the browser-compatible Limbus priority value used by the Lab Priority column. */
    orderPriority?: number | undefined;

    constructor(data?: IOrderHistorySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.jobNumber = _data["jobNumber"];
            this.jobType = _data["jobType"];
            this.status = _data["status"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.clientReference = _data["clientReference"];
            this.quoteNumber = _data["quoteNumber"];
            this.clientOrderNumber = _data["clientOrderNumber"];
            this.contactId = _data["contactId"];
            this.contactName = _data["contactName"];
            this.accountId = _data["accountId"];
            this.clientName = _data["clientName"];
            this.chargeToName = _data["chargeToName"];
            this.jobSourceName = _data["jobSourceName"];
            this.qowqed = _data["qowqed"];
            this.holding = _data["holding"];
            this.holdingReports = _data["holdingReports"];
            this.percentageComplete = _data["percentageComplete"];
            this.orderPriority = _data["orderPriority"];
        }
    }

    static fromJS(data: any): OrderHistorySummary {
        data = typeof data === 'object' ? data : {};
        let result = new OrderHistorySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["jobNumber"] = this.jobNumber;
        data["jobType"] = this.jobType;
        data["status"] = this.status;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["clientReference"] = this.clientReference;
        data["quoteNumber"] = this.quoteNumber;
        data["clientOrderNumber"] = this.clientOrderNumber;
        data["contactId"] = this.contactId;
        data["contactName"] = this.contactName;
        data["accountId"] = this.accountId;
        data["clientName"] = this.clientName;
        data["chargeToName"] = this.chargeToName;
        data["jobSourceName"] = this.jobSourceName;
        data["qowqed"] = this.qowqed;
        data["holding"] = this.holding;
        data["holdingReports"] = this.holdingReports;
        data["percentageComplete"] = this.percentageComplete;
        data["orderPriority"] = this.orderPriority;
        return data;
    }
}

/** Represents one authorised row in the existing My Jobs browser contract. */
export interface IOrderHistorySummary {
    /** Gets the Limbus order identifier when one exists. */
    orderId?: number | undefined;
    /** Gets the LabSys job number when the work item is a job. */
    jobNumber?: number | undefined;
    /** Gets the browser-compatible job type. */
    jobType?: OrderHistoryJobType;
    /** Gets the browser-compatible status. */
    status?: OrderHistoryStatus;
    /** Gets the displayed order date. */
    orderDate?: Date;
    /** Gets the target date when projected. */
    targetDate?: Date | undefined;
    /** Gets the received date when projected. */
    receivedDate?: Date | undefined;
    /** Gets the customer reference. */
    clientReference?: string | undefined;
    /** Gets the quote number. */
    quoteNumber?: string | undefined;
    /** Gets the customer order number. */
    clientOrderNumber?: string | undefined;
    /** Gets the primary LabSys contact identifier. */
    contactId?: number;
    /** Gets the primary role display name. */
    contactName?: string | undefined;
    /** Gets the client organisation identifier when projected. */
    accountId?: number | undefined;
    /** Gets the client display name. */
    clientName?: string | undefined;
    /** Gets the Charge To display name. */
    chargeToName?: string | undefined;
    /** Gets the source name. */
    jobSourceName?: string | undefined;
    /** Gets whether quality control is waiting for query entry or disposition. */
    qowqed?: boolean;
    /** Gets whether the job is on hold. */
    holding?: boolean;
    /** Gets whether reports are on hold. */
    holdingReports?: boolean;
    /** Gets the completion percentage when projected. */
    percentageComplete?: number | undefined;
    /** Gets the browser-compatible Limbus priority value used by the Lab Priority column. */
    orderPriority?: number | undefined;
}

/** Controls whether the recent candidate set includes configured relationship paths. */
export class GetOrdersRequest implements IGetOrdersRequest {

    constructor(data?: IGetOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Controls whether the recent candidate set includes configured relationship paths. */
export interface IGetOrdersRequest {
}

/** Captures the existing browser search contract used by My Jobs. */
export class OrderSearchRequest implements IOrderSearchRequest {
    /** Gets or sets the general text or numeric search value. */
    keyword?: string | undefined;
    /** Gets or sets the requested maximum, capped by the service at 200. */
    maxNumberOfOrders?: number;
    /** Gets or sets whether configured relationship candidates are included. */
    includeOtherUsersInOrg?: boolean;
    /** Gets or sets whether finished and cancelled jobs are excluded. */
    returnUnfinishedJobsOnly?: boolean;
    /** Gets or sets the Limbus order identifiers to match. */
    orderNumbers?: number[];
    /** Gets or sets the customer reference filter. */
    clientReference?: string | undefined;
    /** Gets or sets the additional reference filter. */
    additionalRef?: string | undefined;
    /** Gets or sets the customer order number filter. */
    clientOrderNumber?: string | undefined;
    /** Gets or sets the quote number filter. */
    quoteNumber?: string | undefined;
    /** Gets or sets the Charge To display-name filter. */
    chargeToName?: string | undefined;
    /** Gets or sets the client display-name filter. */
    clientName?: string | undefined;
    /** Gets or sets the Submitter display-name filter. */
    submitterName?: string | undefined;
    /** Gets or sets the Primary display-name filter. */
    primaryContactName?: string | undefined;
    /** Gets or sets the inclusive earliest displayed order date. */
    earliestDate?: Date | undefined;
    /** Gets or sets the inclusive latest displayed order date. */
    latestDate?: Date | undefined;
    /** Gets or sets the LabSys job numbers to match. */
    labJobNumbers?: number[];
    /** Gets or sets the sample name or customer sample identifier filter. */
    sampleNameOrId?: string | undefined;
    /** Gets or sets the browser-compatible job type. */
    jobType?: number | undefined;

    constructor(data?: IOrderSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"];
            this.maxNumberOfOrders = _data["maxNumberOfOrders"];
            this.includeOtherUsersInOrg = _data["includeOtherUsersInOrg"];
            this.returnUnfinishedJobsOnly = _data["returnUnfinishedJobsOnly"];
            if (Array.isArray(_data["orderNumbers"])) {
                this.orderNumbers = [] as any;
                for (let item of _data["orderNumbers"])
                    this.orderNumbers!.push(item);
            }
            this.clientReference = _data["clientReference"];
            this.additionalRef = _data["additionalRef"];
            this.clientOrderNumber = _data["clientOrderNumber"];
            this.quoteNumber = _data["quoteNumber"];
            this.chargeToName = _data["chargeToName"];
            this.clientName = _data["clientName"];
            this.submitterName = _data["submitterName"];
            this.primaryContactName = _data["primaryContactName"];
            this.earliestDate = _data["earliestDate"] ? new Date(_data["earliestDate"].toString()) : <any>undefined;
            this.latestDate = _data["latestDate"] ? new Date(_data["latestDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["labJobNumbers"])) {
                this.labJobNumbers = [] as any;
                for (let item of _data["labJobNumbers"])
                    this.labJobNumbers!.push(item);
            }
            this.sampleNameOrId = _data["sampleNameOrId"];
            this.jobType = _data["jobType"];
        }
    }

    static fromJS(data: any): OrderSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["maxNumberOfOrders"] = this.maxNumberOfOrders;
        data["includeOtherUsersInOrg"] = this.includeOtherUsersInOrg;
        data["returnUnfinishedJobsOnly"] = this.returnUnfinishedJobsOnly;
        if (Array.isArray(this.orderNumbers)) {
            data["orderNumbers"] = [];
            for (let item of this.orderNumbers)
                data["orderNumbers"].push(item);
        }
        data["clientReference"] = this.clientReference;
        data["additionalRef"] = this.additionalRef;
        data["clientOrderNumber"] = this.clientOrderNumber;
        data["quoteNumber"] = this.quoteNumber;
        data["chargeToName"] = this.chargeToName;
        data["clientName"] = this.clientName;
        data["submitterName"] = this.submitterName;
        data["primaryContactName"] = this.primaryContactName;
        data["earliestDate"] = this.earliestDate ? this.earliestDate.toISOString() : <any>undefined;
        data["latestDate"] = this.latestDate ? this.latestDate.toISOString() : <any>undefined;
        if (Array.isArray(this.labJobNumbers)) {
            data["labJobNumbers"] = [];
            for (let item of this.labJobNumbers)
                data["labJobNumbers"].push(item);
        }
        data["sampleNameOrId"] = this.sampleNameOrId;
        data["jobType"] = this.jobType;
        return data;
    }
}

/** Captures the existing browser search contract used by My Jobs. */
export interface IOrderSearchRequest {
    /** Gets or sets the general text or numeric search value. */
    keyword?: string | undefined;
    /** Gets or sets the requested maximum, capped by the service at 200. */
    maxNumberOfOrders?: number;
    /** Gets or sets whether configured relationship candidates are included. */
    includeOtherUsersInOrg?: boolean;
    /** Gets or sets whether finished and cancelled jobs are excluded. */
    returnUnfinishedJobsOnly?: boolean;
    /** Gets or sets the Limbus order identifiers to match. */
    orderNumbers?: number[];
    /** Gets or sets the customer reference filter. */
    clientReference?: string | undefined;
    /** Gets or sets the additional reference filter. */
    additionalRef?: string | undefined;
    /** Gets or sets the customer order number filter. */
    clientOrderNumber?: string | undefined;
    /** Gets or sets the quote number filter. */
    quoteNumber?: string | undefined;
    /** Gets or sets the Charge To display-name filter. */
    chargeToName?: string | undefined;
    /** Gets or sets the client display-name filter. */
    clientName?: string | undefined;
    /** Gets or sets the Submitter display-name filter. */
    submitterName?: string | undefined;
    /** Gets or sets the Primary display-name filter. */
    primaryContactName?: string | undefined;
    /** Gets or sets the inclusive earliest displayed order date. */
    earliestDate?: Date | undefined;
    /** Gets or sets the inclusive latest displayed order date. */
    latestDate?: Date | undefined;
    /** Gets or sets the LabSys job numbers to match. */
    labJobNumbers?: number[];
    /** Gets or sets the sample name or customer sample identifier filter. */
    sampleNameOrId?: string | undefined;
    /** Gets or sets the browser-compatible job type. */
    jobType?: number | undefined;
}

/** Response model for creating a new online identity */
export class CreateOnlineIdentityResponse implements ICreateOnlineIdentityResponse {
    userId?: string;
    limbusContactId?: number;
    email?: string;
    source?: string | undefined;
    emailVerified?: boolean;
    message?: string;

    constructor(data?: ICreateOnlineIdentityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.limbusContactId = _data["limbusContactId"];
            this.email = _data["email"];
            this.source = _data["source"];
            this.emailVerified = _data["emailVerified"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateOnlineIdentityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnlineIdentityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["limbusContactId"] = this.limbusContactId;
        data["email"] = this.email;
        data["source"] = this.source;
        data["emailVerified"] = this.emailVerified;
        data["message"] = this.message;
        return data;
    }
}

/** Response model for creating a new online identity */
export interface ICreateOnlineIdentityResponse {
    userId?: string;
    limbusContactId?: number;
    email?: string;
    source?: string | undefined;
    emailVerified?: boolean;
    message?: string;
}

/** Request model for creating a new online identity */
export class CreateOnlineIdentityRequest implements ICreateOnlineIdentityRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    limbusContactId?: number;
    source?: string | undefined;
    emailVerified?: boolean;

    constructor(data?: ICreateOnlineIdentityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.limbusContactId = _data["limbusContactId"];
            this.source = _data["source"];
            this.emailVerified = _data["emailVerified"];
        }
    }

    static fromJS(data: any): CreateOnlineIdentityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnlineIdentityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["limbusContactId"] = this.limbusContactId;
        data["source"] = this.source;
        data["emailVerified"] = this.emailVerified;
        return data;
    }
}

/** Request model for creating a new online identity */
export interface ICreateOnlineIdentityRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    limbusContactId?: number;
    source?: string | undefined;
    emailVerified?: boolean;
}

/** Response model for online identity status */
export class OnlineIdentityStatusResponse implements IOnlineIdentityStatusResponse {
    userId?: string;
    status?: string;
    isBlocked?: boolean;
    isEmailVerified?: boolean;
    loginHistory?: OnlineIdentityLoginHistoryResponse[];

    constructor(data?: IOnlineIdentityStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.status = _data["status"];
            this.isBlocked = _data["isBlocked"];
            this.isEmailVerified = _data["isEmailVerified"];
            if (Array.isArray(_data["loginHistory"])) {
                this.loginHistory = [] as any;
                for (let item of _data["loginHistory"])
                    this.loginHistory!.push(OnlineIdentityLoginHistoryResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OnlineIdentityStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineIdentityStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["status"] = this.status;
        data["isBlocked"] = this.isBlocked;
        data["isEmailVerified"] = this.isEmailVerified;
        if (Array.isArray(this.loginHistory)) {
            data["loginHistory"] = [];
            for (let item of this.loginHistory)
                data["loginHistory"].push(item.toJSON());
        }
        return data;
    }
}

/** Response model for online identity status */
export interface IOnlineIdentityStatusResponse {
    userId?: string;
    status?: string;
    isBlocked?: boolean;
    isEmailVerified?: boolean;
    loginHistory?: OnlineIdentityLoginHistoryResponse[];
}

/** Login history entry for online identity status response */
export class OnlineIdentityLoginHistoryResponse implements IOnlineIdentityLoginHistoryResponse {
    applicationId?: string;
    applicationName?: string;
    lastLogin?: Date;

    constructor(data?: IOnlineIdentityLoginHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OnlineIdentityLoginHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OnlineIdentityLoginHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>undefined;
        return data;
    }
}

/** Login history entry for online identity status response */
export interface IOnlineIdentityLoginHistoryResponse {
    applicationId?: string;
    applicationName?: string;
    lastLogin?: Date;
}

/** Request model for getting online identity status */
export class GetOnlineIdentityStatusRequest implements IGetOnlineIdentityStatusRequest {

    constructor(data?: IGetOnlineIdentityStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOnlineIdentityStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnlineIdentityStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for getting online identity status */
export interface IGetOnlineIdentityStatusRequest {
}

/** Response model for sending reset password email to a contact's online identity */
export class SendResetPasswordEmailResponse implements ISendResetPasswordEmailResponse {
    userId?: string;
    limbusContactId?: number;
    email?: string;
    message?: string;

    constructor(data?: ISendResetPasswordEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.limbusContactId = _data["limbusContactId"];
            this.email = _data["email"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendResetPasswordEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetPasswordEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["limbusContactId"] = this.limbusContactId;
        data["email"] = this.email;
        data["message"] = this.message;
        return data;
    }
}

/** Response model for sending reset password email to a contact's online identity */
export interface ISendResetPasswordEmailResponse {
    userId?: string;
    limbusContactId?: number;
    email?: string;
    message?: string;
}

/** Request model for sending reset password email to a contact's online identity */
export class SendResetPasswordEmailRequest implements ISendResetPasswordEmailRequest {

    constructor(data?: ISendResetPasswordEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendResetPasswordEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetPasswordEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for sending reset password email to a contact's online identity */
export interface ISendResetPasswordEmailRequest {
}

/** Response model for sending verification email to a contact's online identity */
export class SendVerificationEmailResponse implements ISendVerificationEmailResponse {
    userId?: string;
    limbusContactId?: number;
    message?: string;

    constructor(data?: ISendVerificationEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.limbusContactId = _data["limbusContactId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendVerificationEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["limbusContactId"] = this.limbusContactId;
        data["message"] = this.message;
        return data;
    }
}

/** Response model for sending verification email to a contact's online identity */
export interface ISendVerificationEmailResponse {
    userId?: string;
    limbusContactId?: number;
    message?: string;
}

/** Request model for sending verification email to a contact's online identity */
export class SendVerificationEmailRequest implements ISendVerificationEmailRequest {

    constructor(data?: ISendVerificationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendVerificationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Request model for sending verification email to a contact's online identity */
export interface ISendVerificationEmailRequest {
}

export class AddFavouriteSampleTypeResponse implements IAddFavouriteSampleTypeResponse {
    /** The FavouriteSampleTypeId of the sample type favourite */
    favouriteSampleTypeId?: string;
    /** The SampleTypeId of the sample type favourite */
    sampleTypeId?: number;

    constructor(data?: IAddFavouriteSampleTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.favouriteSampleTypeId = _data["favouriteSampleTypeId"];
            this.sampleTypeId = _data["sampleTypeId"];
        }
    }

    static fromJS(data: any): AddFavouriteSampleTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddFavouriteSampleTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["favouriteSampleTypeId"] = this.favouriteSampleTypeId;
        data["sampleTypeId"] = this.sampleTypeId;
        return data;
    }
}

export interface IAddFavouriteSampleTypeResponse {
    /** The FavouriteSampleTypeId of the sample type favourite */
    favouriteSampleTypeId?: string;
    /** The SampleTypeId of the sample type favourite */
    sampleTypeId?: number;
}

export class ClaimOrderResponse implements IClaimOrderResponse {
    /** The orderId of the order to claim */
    orderId?: string;
    /** The authId of the creator, or GUEST */
    createdBy?: string;

    constructor(data?: IClaimOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): ClaimOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IClaimOrderResponse {
    /** The orderId of the order to claim */
    orderId?: string;
    /** The authId of the creator, or GUEST */
    createdBy?: string;
}

export class CreateOrderResponse implements ICreateOrderResponse {
    /** The orderId for the newly created order */
    orderId?: string;
    /** The authId of the creator, or GUEST */
    createdBy?: string | undefined;

    constructor(data?: ICreateOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): CreateOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface ICreateOrderResponse {
    /** The orderId for the newly created order */
    orderId?: string;
    /** The authId of the creator, or GUEST */
    createdBy?: string | undefined;
}

export class CreateOrderRequest implements ICreateOrderRequest {
    orderTemplateId?: string | undefined;
    /** Controls pricing for the template lookup performed while creating the draft; omission preserves priced API behavior. */
    includePricing?: boolean;

    constructor(data?: ICreateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.includePricing = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplateId = _data["orderTemplateId"];
            this.includePricing = _data["includePricing"] !== undefined ? _data["includePricing"] : true;
        }
    }

    static fromJS(data: any): CreateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplateId"] = this.orderTemplateId;
        data["includePricing"] = this.includePricing;
        return data;
    }
}

export interface ICreateOrderRequest {
    orderTemplateId?: string | undefined;
    /** Controls pricing for the template lookup performed while creating the draft; omission preserves priced API behavior. */
    includePricing?: boolean;
}

export class DeleteFavouriteSampleTypeResponse implements IDeleteFavouriteSampleTypeResponse {
    /** The SampleTypeId of the sample type favourite */
    sampleTypeId?: number;

    constructor(data?: IDeleteFavouriteSampleTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleTypeId = _data["sampleTypeId"];
        }
    }

    static fromJS(data: any): DeleteFavouriteSampleTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFavouriteSampleTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleTypeId"] = this.sampleTypeId;
        return data;
    }
}

export interface IDeleteFavouriteSampleTypeResponse {
    /** The SampleTypeId of the sample type favourite */
    sampleTypeId?: number;
}

export class DeleteOrderRequest implements IDeleteOrderRequest {

    constructor(data?: IDeleteOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteOrderRequest {
}

export class GetLaboratoryTestDetailsResponse implements IGetLaboratoryTestDetailsResponse {
    laboratoryTestDetails?: MyLabLaboratoryTestDetails;

    constructor(data?: IGetLaboratoryTestDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.laboratoryTestDetails = _data["laboratoryTestDetails"] ? MyLabLaboratoryTestDetails.fromJS(_data["laboratoryTestDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetLaboratoryTestDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryTestDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["laboratoryTestDetails"] = this.laboratoryTestDetails ? this.laboratoryTestDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetLaboratoryTestDetailsResponse {
    laboratoryTestDetails?: MyLabLaboratoryTestDetails;
}

export class MyLabLaboratoryTestDetails implements IMyLabLaboratoryTestDetails {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    descriptionHtml?: string;
    operationalDescriptionHtml?: string;
    operationalDescription?: string;
    measurands?: string;
    measurandsHtml?: string;
    turnAroundDays?: number | undefined;
    timeRequirement?: string;
    tempRequirement?: string;
    measurandNames?: string[];

    constructor(data?: IMyLabLaboratoryTestDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.descriptionHtml = _data["descriptionHtml"];
            this.operationalDescriptionHtml = _data["operationalDescriptionHtml"];
            this.operationalDescription = _data["operationalDescription"];
            this.measurands = _data["measurands"];
            this.measurandsHtml = _data["measurandsHtml"];
            this.turnAroundDays = _data["turnAroundDays"];
            this.timeRequirement = _data["timeRequirement"];
            this.tempRequirement = _data["tempRequirement"];
            if (Array.isArray(_data["measurandNames"])) {
                this.measurandNames = [] as any;
                for (let item of _data["measurandNames"])
                    this.measurandNames!.push(item);
            }
        }
    }

    static fromJS(data: any): MyLabLaboratoryTestDetails {
        data = typeof data === 'object' ? data : {};
        let result = new MyLabLaboratoryTestDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["descriptionHtml"] = this.descriptionHtml;
        data["operationalDescriptionHtml"] = this.operationalDescriptionHtml;
        data["operationalDescription"] = this.operationalDescription;
        data["measurands"] = this.measurands;
        data["measurandsHtml"] = this.measurandsHtml;
        data["turnAroundDays"] = this.turnAroundDays;
        data["timeRequirement"] = this.timeRequirement;
        data["tempRequirement"] = this.tempRequirement;
        if (Array.isArray(this.measurandNames)) {
            data["measurandNames"] = [];
            for (let item of this.measurandNames)
                data["measurandNames"].push(item);
        }
        return data;
    }
}

export interface IMyLabLaboratoryTestDetails {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    descriptionHtml?: string;
    operationalDescriptionHtml?: string;
    operationalDescription?: string;
    measurands?: string;
    measurandsHtml?: string;
    turnAroundDays?: number | undefined;
    timeRequirement?: string;
    tempRequirement?: string;
    measurandNames?: string[];
}

export class GetLaboratoryTestDetailsRequest implements IGetLaboratoryTestDetailsRequest {

    constructor(data?: IGetLaboratoryTestDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetLaboratoryTestDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLaboratoryTestDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetLaboratoryTestDetailsRequest {
}

export class GetLabTestsResponse implements IGetLabTestsResponse {
    labTests?: LabTestSummaryRest[];

    constructor(data?: IGetLabTestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labTests"])) {
                this.labTests = [] as any;
                for (let item of _data["labTests"])
                    this.labTests!.push(LabTestSummaryRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLabTestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetLabTestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labTests)) {
            data["labTests"] = [];
            for (let item of this.labTests)
                data["labTests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLabTestsResponse {
    labTests?: LabTestSummaryRest[];
}

export class LabTestSummaryRest implements ILabTestSummaryRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    price?: string;
    validForComposite?: boolean;
    validForComponent?: boolean;
    popularityRank?: number | undefined;
    isFavourite?: boolean;
    measurandNames?: string[];

    constructor(data?: ILabTestSummaryRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.price = _data["price"];
            this.validForComposite = _data["validForComposite"];
            this.validForComponent = _data["validForComponent"];
            this.popularityRank = _data["popularityRank"];
            this.isFavourite = _data["isFavourite"];
            if (Array.isArray(_data["measurandNames"])) {
                this.measurandNames = [] as any;
                for (let item of _data["measurandNames"])
                    this.measurandNames!.push(item);
            }
        }
    }

    static fromJS(data: any): LabTestSummaryRest {
        data = typeof data === 'object' ? data : {};
        let result = new LabTestSummaryRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["price"] = this.price;
        data["validForComposite"] = this.validForComposite;
        data["validForComponent"] = this.validForComponent;
        data["popularityRank"] = this.popularityRank;
        data["isFavourite"] = this.isFavourite;
        if (Array.isArray(this.measurandNames)) {
            data["measurandNames"] = [];
            for (let item of this.measurandNames)
                data["measurandNames"].push(item);
        }
        return data;
    }
}

export interface ILabTestSummaryRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    price?: string;
    validForComposite?: boolean;
    validForComponent?: boolean;
    popularityRank?: number | undefined;
    isFavourite?: boolean;
    measurandNames?: string[];
}

export class GetLabTestsRequest implements IGetLabTestsRequest {

    constructor(data?: IGetLabTestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetLabTestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetLabTestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetLabTestsRequest {
}

export class GetOrderResponse implements IGetOrderResponse {
    order?: MyLabOrderRest;

    constructor(data?: IGetOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? MyLabOrderRest.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrderResponse {
    order?: MyLabOrderRest;
}

export class MyLabOrderRest implements IMyLabOrderRest {
    orderId?: string;
    orderTemplateId?: string | undefined;
    orderSamples?: MyLabOrderSampleRest[];
    orderReference?: string;
    purchaseOrderNumber?: string;
    additionalReference?: string;
    additionalInformation?: string;
    orderContact?: OrderContactRest;
    labPriorityId?: number | undefined;
    isUrgent?: boolean;
    recommendedSamplingItemsRequested?: boolean | undefined;

    constructor(data?: IMyLabOrderRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderTemplateId = _data["orderTemplateId"];
            if (Array.isArray(_data["orderSamples"])) {
                this.orderSamples = [] as any;
                for (let item of _data["orderSamples"])
                    this.orderSamples!.push(MyLabOrderSampleRest.fromJS(item));
            }
            this.orderReference = _data["orderReference"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.additionalReference = _data["additionalReference"];
            this.additionalInformation = _data["additionalInformation"];
            this.orderContact = _data["orderContact"] ? OrderContactRest.fromJS(_data["orderContact"]) : <any>undefined;
            this.labPriorityId = _data["labPriorityId"];
            this.isUrgent = _data["isUrgent"];
            this.recommendedSamplingItemsRequested = _data["recommendedSamplingItemsRequested"];
        }
    }

    static fromJS(data: any): MyLabOrderRest {
        data = typeof data === 'object' ? data : {};
        let result = new MyLabOrderRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderTemplateId"] = this.orderTemplateId;
        if (Array.isArray(this.orderSamples)) {
            data["orderSamples"] = [];
            for (let item of this.orderSamples)
                data["orderSamples"].push(item.toJSON());
        }
        data["orderReference"] = this.orderReference;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["additionalReference"] = this.additionalReference;
        data["additionalInformation"] = this.additionalInformation;
        data["orderContact"] = this.orderContact ? this.orderContact.toJSON() : <any>undefined;
        data["labPriorityId"] = this.labPriorityId;
        data["isUrgent"] = this.isUrgent;
        data["recommendedSamplingItemsRequested"] = this.recommendedSamplingItemsRequested;
        return data;
    }
}

export interface IMyLabOrderRest {
    orderId?: string;
    orderTemplateId?: string | undefined;
    orderSamples?: MyLabOrderSampleRest[];
    orderReference?: string;
    purchaseOrderNumber?: string;
    additionalReference?: string;
    additionalInformation?: string;
    orderContact?: OrderContactRest;
    labPriorityId?: number | undefined;
    isUrgent?: boolean;
    recommendedSamplingItemsRequested?: boolean | undefined;
}

export class MyLabOrderSampleRest implements IMyLabOrderSampleRest {
    orderSampleId?: string;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleType?: MyLabSampleTypeRest | undefined;
    analyticalTests?: OrderSampleAnalyticalTestRest[];
    laboratoryServices?: OrderSampleLaboratoryServiceRest[];
    samplingItems?: OrderSampleSamplingItemRest[];
    containerItem?: OrderSampleContainerItemRest;
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    canBeComposited?: boolean;
    isComposited?: boolean;
    sampleParameters?: OrderSampleParameterRest[];
    compositeComponents?: string[];
    orderBlueprintSampleId?: number | undefined;
    orderBlueprintLineId?: number | undefined;
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];

    constructor(data?: IMyLabOrderSampleRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSampleId = _data["orderSampleId"];
            this.name = _data["name"];
            this.clientSampleId = _data["clientSampleId"];
            this.sequence = _data["sequence"];
            this.sampleDateTime = _data["sampleDateTime"] ? new Date(_data["sampleDateTime"].toString()) : <any>undefined;
            this.sampleType = _data["sampleType"] ? MyLabSampleTypeRest.fromJS(_data["sampleType"]) : <any>undefined;
            if (Array.isArray(_data["analyticalTests"])) {
                this.analyticalTests = [] as any;
                for (let item of _data["analyticalTests"])
                    this.analyticalTests!.push(OrderSampleAnalyticalTestRest.fromJS(item));
            }
            if (Array.isArray(_data["laboratoryServices"])) {
                this.laboratoryServices = [] as any;
                for (let item of _data["laboratoryServices"])
                    this.laboratoryServices!.push(OrderSampleLaboratoryServiceRest.fromJS(item));
            }
            if (Array.isArray(_data["samplingItems"])) {
                this.samplingItems = [] as any;
                for (let item of _data["samplingItems"])
                    this.samplingItems!.push(OrderSampleSamplingItemRest.fromJS(item));
            }
            this.containerItem = _data["containerItem"] ? OrderSampleContainerItemRest.fromJS(_data["containerItem"]) : <any>undefined;
            this.isComposite = _data["isComposite"];
            this.sampleCompositeTypeId = _data["sampleCompositeTypeId"];
            this.canBeComposited = _data["canBeComposited"];
            this.isComposited = _data["isComposited"];
            if (Array.isArray(_data["sampleParameters"])) {
                this.sampleParameters = [] as any;
                for (let item of _data["sampleParameters"])
                    this.sampleParameters!.push(OrderSampleParameterRest.fromJS(item));
            }
            if (Array.isArray(_data["compositeComponents"])) {
                this.compositeComponents = [] as any;
                for (let item of _data["compositeComponents"])
                    this.compositeComponents!.push(item);
            }
            this.orderBlueprintSampleId = _data["orderBlueprintSampleId"];
            this.orderBlueprintLineId = _data["orderBlueprintLineId"];
            if (Array.isArray(_data["organisationSampleIdentifiers"])) {
                this.organisationSampleIdentifiers = [] as any;
                for (let item of _data["organisationSampleIdentifiers"])
                    this.organisationSampleIdentifiers!.push(OrderSampleOrganisationSampleIdentifierRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyLabOrderSampleRest {
        data = typeof data === 'object' ? data : {};
        let result = new MyLabOrderSampleRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSampleId"] = this.orderSampleId;
        data["name"] = this.name;
        data["clientSampleId"] = this.clientSampleId;
        data["sequence"] = this.sequence;
        data["sampleDateTime"] = this.sampleDateTime ? this.sampleDateTime.toISOString() : <any>undefined;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>undefined;
        if (Array.isArray(this.analyticalTests)) {
            data["analyticalTests"] = [];
            for (let item of this.analyticalTests)
                data["analyticalTests"].push(item.toJSON());
        }
        if (Array.isArray(this.laboratoryServices)) {
            data["laboratoryServices"] = [];
            for (let item of this.laboratoryServices)
                data["laboratoryServices"].push(item.toJSON());
        }
        if (Array.isArray(this.samplingItems)) {
            data["samplingItems"] = [];
            for (let item of this.samplingItems)
                data["samplingItems"].push(item.toJSON());
        }
        data["containerItem"] = this.containerItem ? this.containerItem.toJSON() : <any>undefined;
        data["isComposite"] = this.isComposite;
        data["sampleCompositeTypeId"] = this.sampleCompositeTypeId;
        data["canBeComposited"] = this.canBeComposited;
        data["isComposited"] = this.isComposited;
        if (Array.isArray(this.sampleParameters)) {
            data["sampleParameters"] = [];
            for (let item of this.sampleParameters)
                data["sampleParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.compositeComponents)) {
            data["compositeComponents"] = [];
            for (let item of this.compositeComponents)
                data["compositeComponents"].push(item);
        }
        data["orderBlueprintSampleId"] = this.orderBlueprintSampleId;
        data["orderBlueprintLineId"] = this.orderBlueprintLineId;
        if (Array.isArray(this.organisationSampleIdentifiers)) {
            data["organisationSampleIdentifiers"] = [];
            for (let item of this.organisationSampleIdentifiers)
                data["organisationSampleIdentifiers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyLabOrderSampleRest {
    orderSampleId?: string;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleType?: MyLabSampleTypeRest | undefined;
    analyticalTests?: OrderSampleAnalyticalTestRest[];
    laboratoryServices?: OrderSampleLaboratoryServiceRest[];
    samplingItems?: OrderSampleSamplingItemRest[];
    containerItem?: OrderSampleContainerItemRest;
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    canBeComposited?: boolean;
    isComposited?: boolean;
    sampleParameters?: OrderSampleParameterRest[];
    compositeComponents?: string[];
    orderBlueprintSampleId?: number | undefined;
    orderBlueprintLineId?: number | undefined;
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];
}

export class MyLabSampleTypeRest implements IMyLabSampleTypeRest {
    sampleTypeId?: number;
    code?: string;
    name?: string;
    isFavourite?: boolean;

    constructor(data?: IMyLabSampleTypeRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleTypeId = _data["sampleTypeId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): MyLabSampleTypeRest {
        data = typeof data === 'object' ? data : {};
        let result = new MyLabSampleTypeRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleTypeId"] = this.sampleTypeId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IMyLabSampleTypeRest {
    sampleTypeId?: number;
    code?: string;
    name?: string;
    isFavourite?: boolean;
}

export class OrderSampleAnalyticalTestRest implements IOrderSampleAnalyticalTestRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;

    constructor(data?: IOrderSampleAnalyticalTestRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): OrderSampleAnalyticalTestRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleAnalyticalTestRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IOrderSampleAnalyticalTestRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
}

export class OrderSampleLaboratoryServiceRest implements IOrderSampleLaboratoryServiceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;

    constructor(data?: IOrderSampleLaboratoryServiceRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): OrderSampleLaboratoryServiceRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleLaboratoryServiceRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IOrderSampleLaboratoryServiceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
}

export class OrderSampleSamplingItemRest implements IOrderSampleSamplingItemRest {
    catalogueItemId?: number;
    orderSampleId?: string;
    name?: string;
    code?: string;
    quantity?: number;

    constructor(data?: IOrderSampleSamplingItemRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.orderSampleId = _data["orderSampleId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): OrderSampleSamplingItemRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleSamplingItemRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["orderSampleId"] = this.orderSampleId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IOrderSampleSamplingItemRest {
    catalogueItemId?: number;
    orderSampleId?: string;
    name?: string;
    code?: string;
    quantity?: number;
}

export class OrderSampleContainerItemRest implements IOrderSampleContainerItemRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;

    constructor(data?: IOrderSampleContainerItemRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.catalogueItemId = _data["catalogueItemId"];
        }
    }

    static fromJS(data: any): OrderSampleContainerItemRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleContainerItemRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["catalogueItemId"] = this.catalogueItemId;
        return data;
    }
}

export interface IOrderSampleContainerItemRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;
}

export class OrderSampleParameterRest implements IOrderSampleParameterRest {
    orderSampleParameterId?: string;
    name?: string;
    type?: string;
    validationConfiguration?: SampleParameterValidationConfigurationRest;
    isRequired?: boolean;
    value?: string;
    testId?: number;
    testName?: string;
    orderSampleId?: string;
    orderSampleSequence?: number;
    orderSampleName?: string;
    limbusSampleParameterId?: number;

    constructor(data?: IOrderSampleParameterRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSampleParameterId = _data["orderSampleParameterId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.validationConfiguration = _data["validationConfiguration"] ? SampleParameterValidationConfigurationRest.fromJS(_data["validationConfiguration"]) : <any>undefined;
            this.isRequired = _data["isRequired"];
            this.value = _data["value"];
            this.testId = _data["testId"];
            this.testName = _data["testName"];
            this.orderSampleId = _data["orderSampleId"];
            this.orderSampleSequence = _data["orderSampleSequence"];
            this.orderSampleName = _data["orderSampleName"];
            this.limbusSampleParameterId = _data["limbusSampleParameterId"];
        }
    }

    static fromJS(data: any): OrderSampleParameterRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleParameterRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSampleParameterId"] = this.orderSampleParameterId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["validationConfiguration"] = this.validationConfiguration ? this.validationConfiguration.toJSON() : <any>undefined;
        data["isRequired"] = this.isRequired;
        data["value"] = this.value;
        data["testId"] = this.testId;
        data["testName"] = this.testName;
        data["orderSampleId"] = this.orderSampleId;
        data["orderSampleSequence"] = this.orderSampleSequence;
        data["orderSampleName"] = this.orderSampleName;
        data["limbusSampleParameterId"] = this.limbusSampleParameterId;
        return data;
    }
}

export interface IOrderSampleParameterRest {
    orderSampleParameterId?: string;
    name?: string;
    type?: string;
    validationConfiguration?: SampleParameterValidationConfigurationRest;
    isRequired?: boolean;
    value?: string;
    testId?: number;
    testName?: string;
    orderSampleId?: string;
    orderSampleSequence?: number;
    orderSampleName?: string;
    limbusSampleParameterId?: number;
}

export class SampleParameterValidationConfigurationRest implements ISampleParameterValidationConfigurationRest {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;

    constructor(data?: ISampleParameterValidationConfigurationRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
        }
    }

    static fromJS(data: any): SampleParameterValidationConfigurationRest {
        data = typeof data === 'object' ? data : {};
        let result = new SampleParameterValidationConfigurationRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        return data;
    }
}

export interface ISampleParameterValidationConfigurationRest {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
}

export class OrderSampleOrganisationSampleIdentifierRest implements IOrderSampleOrganisationSampleIdentifierRest {
    organisationSampleIdentifierId?: string;
    value?: string;
    name?: string;
    sequence?: number;

    constructor(data?: IOrderSampleOrganisationSampleIdentifierRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationSampleIdentifierId = _data["organisationSampleIdentifierId"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.sequence = _data["sequence"];
        }
    }

    static fromJS(data: any): OrderSampleOrganisationSampleIdentifierRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleOrganisationSampleIdentifierRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationSampleIdentifierId"] = this.organisationSampleIdentifierId;
        data["value"] = this.value;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        return data;
    }
}

export interface IOrderSampleOrganisationSampleIdentifierRest {
    organisationSampleIdentifierId?: string;
    value?: string;
    name?: string;
    sequence?: number;
}

export class OrderContactRest implements IOrderContactRest {
    contactId?: number;
    parentOrganisationId?: number | undefined;
    firstName?: string;
    lastName?: string;
    email?: string;
    company?: string;
    deliveryAddress?: OrderContactAddressRest;

    constructor(data?: IOrderContactRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.parentOrganisationId = _data["parentOrganisationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.company = _data["company"];
            this.deliveryAddress = _data["deliveryAddress"] ? OrderContactAddressRest.fromJS(_data["deliveryAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderContactRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderContactRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["parentOrganisationId"] = this.parentOrganisationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["company"] = this.company;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrderContactRest {
    contactId?: number;
    parentOrganisationId?: number | undefined;
    firstName?: string;
    lastName?: string;
    email?: string;
    company?: string;
    deliveryAddress?: OrderContactAddressRest;
}

export class OrderContactAddressRest implements IOrderContactAddressRest {
    recipientInfo?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    postcode?: string;

    constructor(data?: IOrderContactAddressRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipientInfo = _data["recipientInfo"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
        }
    }

    static fromJS(data: any): OrderContactAddressRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderContactAddressRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipientInfo"] = this.recipientInfo;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        return data;
    }
}

export interface IOrderContactAddressRest {
    recipientInfo?: string;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    postcode?: string;
}

export class GetOrderRequest implements IGetOrderRequest {

    constructor(data?: IGetOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderRequest {
}

export class GetOrderSampleParametersResponse implements IGetOrderSampleParametersResponse {
    orderSampleParameters?: OrderSampleParameterRest[];

    constructor(data?: IGetOrderSampleParametersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSampleParameters"])) {
                this.orderSampleParameters = [] as any;
                for (let item of _data["orderSampleParameters"])
                    this.orderSampleParameters!.push(OrderSampleParameterRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrderSampleParametersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderSampleParametersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSampleParameters)) {
            data["orderSampleParameters"] = [];
            for (let item of this.orderSampleParameters)
                data["orderSampleParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrderSampleParametersResponse {
    orderSampleParameters?: OrderSampleParameterRest[];
}

export class GetOrderSampleParametersRequest implements IGetOrderSampleParametersRequest {

    constructor(data?: IGetOrderSampleParametersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderSampleParametersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderSampleParametersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderSampleParametersRequest {
}

export class GetOrderTemplateResponse implements IGetOrderTemplateResponse {
    orderTemplate?: OrderTemplateRest;

    constructor(data?: IGetOrderTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplate = _data["orderTemplate"] ? OrderTemplateRest.fromJS(_data["orderTemplate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplate"] = this.orderTemplate ? this.orderTemplate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrderTemplateResponse {
    orderTemplate?: OrderTemplateRest;
}

export class OrderTemplateRest implements IOrderTemplateRest {
    orderTemplateId?: string;
    name?: string;
    description?: string;
    quoteNumber?: number;
    additionalInformation?: string | undefined;
    additionalReference?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    orderReference?: string | undefined;
    labPriorityId?: number | undefined;
    orderTemplateLines?: OrderTemplateLineRest[];

    constructor(data?: IOrderTemplateRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplateId = _data["orderTemplateId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.quoteNumber = _data["quoteNumber"];
            this.additionalInformation = _data["additionalInformation"];
            this.additionalReference = _data["additionalReference"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.orderReference = _data["orderReference"];
            this.labPriorityId = _data["labPriorityId"];
            if (Array.isArray(_data["orderTemplateLines"])) {
                this.orderTemplateLines = [] as any;
                for (let item of _data["orderTemplateLines"])
                    this.orderTemplateLines!.push(OrderTemplateLineRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderTemplateRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplateId"] = this.orderTemplateId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["quoteNumber"] = this.quoteNumber;
        data["additionalInformation"] = this.additionalInformation;
        data["additionalReference"] = this.additionalReference;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["orderReference"] = this.orderReference;
        data["labPriorityId"] = this.labPriorityId;
        if (Array.isArray(this.orderTemplateLines)) {
            data["orderTemplateLines"] = [];
            for (let item of this.orderTemplateLines)
                data["orderTemplateLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderTemplateRest {
    orderTemplateId?: string;
    name?: string;
    description?: string;
    quoteNumber?: number;
    additionalInformation?: string | undefined;
    additionalReference?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    orderReference?: string | undefined;
    labPriorityId?: number | undefined;
    orderTemplateLines?: OrderTemplateLineRest[];
}

export class OrderTemplateLineRest implements IOrderTemplateLineRest {
    orderTemplateSampleId?: number | undefined;
    orderTemplateLineId?: number;
    heading?: string;
    name?: string;
    unitPrice?: number;
    quantity?: number;
    sampleType?: MyLabSampleTypeRest;
    analyticalTests?: OrderTemplateAnalyticalTestRest[];
    containerItem?: OrderTemplateContainerItemRest;
    clientSampleId?: string;
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    validSampleTypeIdsForComponents?: number[];
    maxNumberOfComponents?: number;
    maxCompositeNumber?: number | undefined;
    componentLines?: OrderTemplateLineRest[];

    constructor(data?: IOrderTemplateLineRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplateSampleId = _data["orderTemplateSampleId"];
            this.orderTemplateLineId = _data["orderTemplateLineId"];
            this.heading = _data["heading"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.sampleType = _data["sampleType"] ? MyLabSampleTypeRest.fromJS(_data["sampleType"]) : <any>undefined;
            if (Array.isArray(_data["analyticalTests"])) {
                this.analyticalTests = [] as any;
                for (let item of _data["analyticalTests"])
                    this.analyticalTests!.push(OrderTemplateAnalyticalTestRest.fromJS(item));
            }
            this.containerItem = _data["containerItem"] ? OrderTemplateContainerItemRest.fromJS(_data["containerItem"]) : <any>undefined;
            this.clientSampleId = _data["clientSampleId"];
            this.isComposite = _data["isComposite"];
            this.sampleCompositeTypeId = _data["sampleCompositeTypeId"];
            if (Array.isArray(_data["validSampleTypeIdsForComponents"])) {
                this.validSampleTypeIdsForComponents = [] as any;
                for (let item of _data["validSampleTypeIdsForComponents"])
                    this.validSampleTypeIdsForComponents!.push(item);
            }
            this.maxNumberOfComponents = _data["maxNumberOfComponents"];
            this.maxCompositeNumber = _data["maxCompositeNumber"];
            if (Array.isArray(_data["componentLines"])) {
                this.componentLines = [] as any;
                for (let item of _data["componentLines"])
                    this.componentLines!.push(OrderTemplateLineRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderTemplateLineRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateLineRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplateSampleId"] = this.orderTemplateSampleId;
        data["orderTemplateLineId"] = this.orderTemplateLineId;
        data["heading"] = this.heading;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>undefined;
        if (Array.isArray(this.analyticalTests)) {
            data["analyticalTests"] = [];
            for (let item of this.analyticalTests)
                data["analyticalTests"].push(item.toJSON());
        }
        data["containerItem"] = this.containerItem ? this.containerItem.toJSON() : <any>undefined;
        data["clientSampleId"] = this.clientSampleId;
        data["isComposite"] = this.isComposite;
        data["sampleCompositeTypeId"] = this.sampleCompositeTypeId;
        if (Array.isArray(this.validSampleTypeIdsForComponents)) {
            data["validSampleTypeIdsForComponents"] = [];
            for (let item of this.validSampleTypeIdsForComponents)
                data["validSampleTypeIdsForComponents"].push(item);
        }
        data["maxNumberOfComponents"] = this.maxNumberOfComponents;
        data["maxCompositeNumber"] = this.maxCompositeNumber;
        if (Array.isArray(this.componentLines)) {
            data["componentLines"] = [];
            for (let item of this.componentLines)
                data["componentLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderTemplateLineRest {
    orderTemplateSampleId?: number | undefined;
    orderTemplateLineId?: number;
    heading?: string;
    name?: string;
    unitPrice?: number;
    quantity?: number;
    sampleType?: MyLabSampleTypeRest;
    analyticalTests?: OrderTemplateAnalyticalTestRest[];
    containerItem?: OrderTemplateContainerItemRest;
    clientSampleId?: string;
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    validSampleTypeIdsForComponents?: number[];
    maxNumberOfComponents?: number;
    maxCompositeNumber?: number | undefined;
    componentLines?: OrderTemplateLineRest[];
}

export class OrderTemplateAnalyticalTestRest implements IOrderTemplateAnalyticalTestRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;
    validForComponent?: boolean;
    validForComposite?: boolean;
    measurandNames?: string[];

    constructor(data?: IOrderTemplateAnalyticalTestRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.catalogueItemId = _data["catalogueItemId"];
            this.validForComponent = _data["validForComponent"];
            this.validForComposite = _data["validForComposite"];
            if (Array.isArray(_data["measurandNames"])) {
                this.measurandNames = [] as any;
                for (let item of _data["measurandNames"])
                    this.measurandNames!.push(item);
            }
        }
    }

    static fromJS(data: any): OrderTemplateAnalyticalTestRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateAnalyticalTestRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["catalogueItemId"] = this.catalogueItemId;
        data["validForComponent"] = this.validForComponent;
        data["validForComposite"] = this.validForComposite;
        if (Array.isArray(this.measurandNames)) {
            data["measurandNames"] = [];
            for (let item of this.measurandNames)
                data["measurandNames"].push(item);
        }
        return data;
    }
}

export interface IOrderTemplateAnalyticalTestRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;
    validForComponent?: boolean;
    validForComposite?: boolean;
    measurandNames?: string[];
}

export class OrderTemplateContainerItemRest implements IOrderTemplateContainerItemRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;

    constructor(data?: IOrderTemplateContainerItemRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.catalogueItemId = _data["catalogueItemId"];
        }
    }

    static fromJS(data: any): OrderTemplateContainerItemRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateContainerItemRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["catalogueItemId"] = this.catalogueItemId;
        return data;
    }
}

export interface IOrderTemplateContainerItemRest {
    code?: string;
    name?: string;
    catalogueItemId?: number;
}

export class GetOrderTemplateRequest implements IGetOrderTemplateRequest {

    constructor(data?: IGetOrderTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderTemplateRequest {
}

export class PaginatedResultOfOrderTemplateLabTestSummaryRest implements IPaginatedResultOfOrderTemplateLabTestSummaryRest {
    items?: OrderTemplateLabTestSummaryRest[];
    totalCount?: number;
    offset?: number;
    limit?: number;

    constructor(data?: IPaginatedResultOfOrderTemplateLabTestSummaryRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrderTemplateLabTestSummaryRest.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.offset = _data["offset"];
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): PaginatedResultOfOrderTemplateLabTestSummaryRest {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedResultOfOrderTemplateLabTestSummaryRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        data["offset"] = this.offset;
        data["limit"] = this.limit;
        return data;
    }
}

export interface IPaginatedResultOfOrderTemplateLabTestSummaryRest {
    items?: OrderTemplateLabTestSummaryRest[];
    totalCount?: number;
    offset?: number;
    limit?: number;
}

export class OrderTemplateLabTestSummaryRest extends LabTestSummaryRest implements IOrderTemplateLabTestSummaryRest {
    source?: string;

    constructor(data?: IOrderTemplateLabTestSummaryRest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.source = _data["source"];
        }
    }

    static override fromJS(data: any): OrderTemplateLabTestSummaryRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateLabTestSummaryRest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        super.toJSON(data);
        return data;
    }
}

export interface IOrderTemplateLabTestSummaryRest extends ILabTestSummaryRest {
    source?: string;
}

export class GetOrderTemplateLabTestsRequest implements IGetOrderTemplateLabTestsRequest {

    constructor(data?: IGetOrderTemplateLabTestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderTemplateLabTestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTemplateLabTestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderTemplateLabTestsRequest {
}

export class GetOrderTemplateSampleTypesResponse implements IGetOrderTemplateSampleTypesResponse {
    sampleTypes?: MyLabSampleTypeRest[];

    constructor(data?: IGetOrderTemplateSampleTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sampleTypes"])) {
                this.sampleTypes = [] as any;
                for (let item of _data["sampleTypes"])
                    this.sampleTypes!.push(MyLabSampleTypeRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOrderTemplateSampleTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTemplateSampleTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sampleTypes)) {
            data["sampleTypes"] = [];
            for (let item of this.sampleTypes)
                data["sampleTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOrderTemplateSampleTypesResponse {
    sampleTypes?: MyLabSampleTypeRest[];
}

export class GetOrderTemplateSampleTypesRequest implements IGetOrderTemplateSampleTypesRequest {

    constructor(data?: IGetOrderTemplateSampleTypesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderTemplateSampleTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderTemplateSampleTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderTemplateSampleTypesRequest {
}

export class GetOrderWithPriceResponse implements IGetOrderWithPriceResponse {
    order?: OrderWithPriceRest;

    constructor(data?: IGetOrderWithPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? OrderWithPriceRest.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOrderWithPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderWithPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOrderWithPriceResponse {
    order?: OrderWithPriceRest;
}

export class OrderWithPriceRest implements IOrderWithPriceRest {
    orderSamples?: OrderSampleWithPriceRest[];
    orderId?: string;
    orderTemplateId?: string | undefined;
    orderReference?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    additionalReference?: string | undefined;
    additionalInformation?: string | undefined;
    maxTurnAroundDays?: number | undefined;
    orderContact?: OrderContactRest;
    isUrgent?: boolean;
    recommendedSamplingItemsRequested?: boolean | undefined;
    setupCharges?: OrderSetupChargesRest[];

    constructor(data?: IOrderWithPriceRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSamples"])) {
                this.orderSamples = [] as any;
                for (let item of _data["orderSamples"])
                    this.orderSamples!.push(OrderSampleWithPriceRest.fromJS(item));
            }
            this.orderId = _data["orderId"];
            this.orderTemplateId = _data["orderTemplateId"];
            this.orderReference = _data["orderReference"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.additionalReference = _data["additionalReference"];
            this.additionalInformation = _data["additionalInformation"];
            this.maxTurnAroundDays = _data["maxTurnAroundDays"];
            this.orderContact = _data["orderContact"] ? OrderContactRest.fromJS(_data["orderContact"]) : <any>undefined;
            this.isUrgent = _data["isUrgent"];
            this.recommendedSamplingItemsRequested = _data["recommendedSamplingItemsRequested"];
            if (Array.isArray(_data["setupCharges"])) {
                this.setupCharges = [] as any;
                for (let item of _data["setupCharges"])
                    this.setupCharges!.push(OrderSetupChargesRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderWithPriceRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderWithPriceRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSamples)) {
            data["orderSamples"] = [];
            for (let item of this.orderSamples)
                data["orderSamples"].push(item.toJSON());
        }
        data["orderId"] = this.orderId;
        data["orderTemplateId"] = this.orderTemplateId;
        data["orderReference"] = this.orderReference;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["additionalReference"] = this.additionalReference;
        data["additionalInformation"] = this.additionalInformation;
        data["maxTurnAroundDays"] = this.maxTurnAroundDays;
        data["orderContact"] = this.orderContact ? this.orderContact.toJSON() : <any>undefined;
        data["isUrgent"] = this.isUrgent;
        data["recommendedSamplingItemsRequested"] = this.recommendedSamplingItemsRequested;
        if (Array.isArray(this.setupCharges)) {
            data["setupCharges"] = [];
            for (let item of this.setupCharges)
                data["setupCharges"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderWithPriceRest {
    orderSamples?: OrderSampleWithPriceRest[];
    orderId?: string;
    orderTemplateId?: string | undefined;
    orderReference?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    additionalReference?: string | undefined;
    additionalInformation?: string | undefined;
    maxTurnAroundDays?: number | undefined;
    orderContact?: OrderContactRest;
    isUrgent?: boolean;
    recommendedSamplingItemsRequested?: boolean | undefined;
    setupCharges?: OrderSetupChargesRest[];
}

export class OrderSampleWithPriceRest implements IOrderSampleWithPriceRest {
    myLabOrderSampleId?: string;
    orderSampleId?: number;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleType?: MyLabSampleTypeRest | undefined;
    sampleTypeId?: number;
    analyticalTests?: OrderSampleAnalyticalTestWithPriceRest[];
    laboratoryServices?: OrderSampleLaboratoryServiceWithPriceRest[];
    samplingItems?: OrderSampleSamplingItemRest[];
    isComposite?: boolean;
    canBeComposited?: boolean;
    isComposited?: boolean;
    compositeComponents?: string[];
    sampleParameters?: OrderSampleParameterRest[];
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];

    constructor(data?: IOrderSampleWithPriceRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.myLabOrderSampleId = _data["myLabOrderSampleId"];
            this.orderSampleId = _data["orderSampleId"];
            this.name = _data["name"];
            this.clientSampleId = _data["clientSampleId"];
            this.sequence = _data["sequence"];
            this.sampleDateTime = _data["sampleDateTime"] ? new Date(_data["sampleDateTime"].toString()) : <any>undefined;
            this.sampleType = _data["sampleType"] ? MyLabSampleTypeRest.fromJS(_data["sampleType"]) : <any>undefined;
            this.sampleTypeId = _data["sampleTypeId"];
            if (Array.isArray(_data["analyticalTests"])) {
                this.analyticalTests = [] as any;
                for (let item of _data["analyticalTests"])
                    this.analyticalTests!.push(OrderSampleAnalyticalTestWithPriceRest.fromJS(item));
            }
            if (Array.isArray(_data["laboratoryServices"])) {
                this.laboratoryServices = [] as any;
                for (let item of _data["laboratoryServices"])
                    this.laboratoryServices!.push(OrderSampleLaboratoryServiceWithPriceRest.fromJS(item));
            }
            if (Array.isArray(_data["samplingItems"])) {
                this.samplingItems = [] as any;
                for (let item of _data["samplingItems"])
                    this.samplingItems!.push(OrderSampleSamplingItemRest.fromJS(item));
            }
            this.isComposite = _data["isComposite"];
            this.canBeComposited = _data["canBeComposited"];
            this.isComposited = _data["isComposited"];
            if (Array.isArray(_data["compositeComponents"])) {
                this.compositeComponents = [] as any;
                for (let item of _data["compositeComponents"])
                    this.compositeComponents!.push(item);
            }
            if (Array.isArray(_data["sampleParameters"])) {
                this.sampleParameters = [] as any;
                for (let item of _data["sampleParameters"])
                    this.sampleParameters!.push(OrderSampleParameterRest.fromJS(item));
            }
            if (Array.isArray(_data["organisationSampleIdentifiers"])) {
                this.organisationSampleIdentifiers = [] as any;
                for (let item of _data["organisationSampleIdentifiers"])
                    this.organisationSampleIdentifiers!.push(OrderSampleOrganisationSampleIdentifierRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderSampleWithPriceRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleWithPriceRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["myLabOrderSampleId"] = this.myLabOrderSampleId;
        data["orderSampleId"] = this.orderSampleId;
        data["name"] = this.name;
        data["clientSampleId"] = this.clientSampleId;
        data["sequence"] = this.sequence;
        data["sampleDateTime"] = this.sampleDateTime ? this.sampleDateTime.toISOString() : <any>undefined;
        data["sampleType"] = this.sampleType ? this.sampleType.toJSON() : <any>undefined;
        data["sampleTypeId"] = this.sampleTypeId;
        if (Array.isArray(this.analyticalTests)) {
            data["analyticalTests"] = [];
            for (let item of this.analyticalTests)
                data["analyticalTests"].push(item.toJSON());
        }
        if (Array.isArray(this.laboratoryServices)) {
            data["laboratoryServices"] = [];
            for (let item of this.laboratoryServices)
                data["laboratoryServices"].push(item.toJSON());
        }
        if (Array.isArray(this.samplingItems)) {
            data["samplingItems"] = [];
            for (let item of this.samplingItems)
                data["samplingItems"].push(item.toJSON());
        }
        data["isComposite"] = this.isComposite;
        data["canBeComposited"] = this.canBeComposited;
        data["isComposited"] = this.isComposited;
        if (Array.isArray(this.compositeComponents)) {
            data["compositeComponents"] = [];
            for (let item of this.compositeComponents)
                data["compositeComponents"].push(item);
        }
        if (Array.isArray(this.sampleParameters)) {
            data["sampleParameters"] = [];
            for (let item of this.sampleParameters)
                data["sampleParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.organisationSampleIdentifiers)) {
            data["organisationSampleIdentifiers"] = [];
            for (let item of this.organisationSampleIdentifiers)
                data["organisationSampleIdentifiers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderSampleWithPriceRest {
    myLabOrderSampleId?: string;
    orderSampleId?: number;
    name?: string | undefined;
    clientSampleId?: string | undefined;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleType?: MyLabSampleTypeRest | undefined;
    sampleTypeId?: number;
    analyticalTests?: OrderSampleAnalyticalTestWithPriceRest[];
    laboratoryServices?: OrderSampleLaboratoryServiceWithPriceRest[];
    samplingItems?: OrderSampleSamplingItemRest[];
    isComposite?: boolean;
    canBeComposited?: boolean;
    isComposited?: boolean;
    compositeComponents?: string[];
    sampleParameters?: OrderSampleParameterRest[];
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];
}

export class OrderSampleAnalyticalTestWithPriceRest implements IOrderSampleAnalyticalTestWithPriceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    isUserAdded?: boolean;
    unitPrice?: string;
    discountedPrice?: string;

    constructor(data?: IOrderSampleAnalyticalTestWithPriceRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isUserAdded = _data["isUserAdded"];
            this.unitPrice = _data["unitPrice"];
            this.discountedPrice = _data["discountedPrice"];
        }
    }

    static fromJS(data: any): OrderSampleAnalyticalTestWithPriceRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleAnalyticalTestWithPriceRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isUserAdded"] = this.isUserAdded;
        data["unitPrice"] = this.unitPrice;
        data["discountedPrice"] = this.discountedPrice;
        return data;
    }
}

export interface IOrderSampleAnalyticalTestWithPriceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    isUserAdded?: boolean;
    unitPrice?: string;
    discountedPrice?: string;
}

export class OrderSampleLaboratoryServiceWithPriceRest implements IOrderSampleLaboratoryServiceWithPriceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    isUserAdded?: boolean;
    unitPrice?: string;
    discountedPrice?: string;

    constructor(data?: IOrderSampleLaboratoryServiceWithPriceRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.isUserAdded = _data["isUserAdded"];
            this.unitPrice = _data["unitPrice"];
            this.discountedPrice = _data["discountedPrice"];
        }
    }

    static fromJS(data: any): OrderSampleLaboratoryServiceWithPriceRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleLaboratoryServiceWithPriceRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["isUserAdded"] = this.isUserAdded;
        data["unitPrice"] = this.unitPrice;
        data["discountedPrice"] = this.discountedPrice;
        return data;
    }
}

export interface IOrderSampleLaboratoryServiceWithPriceRest {
    catalogueItemId?: number;
    name?: string;
    code?: string;
    isUserAdded?: boolean;
    unitPrice?: string;
    discountedPrice?: string;
}

export class OrderSetupChargesRest implements IOrderSetupChargesRest {
    catalogueItemId?: number;
    name?: string;
    unitPrice?: number;
    discountedPrice?: number;

    constructor(data?: IOrderSetupChargesRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.discountedPrice = _data["discountedPrice"];
        }
    }

    static fromJS(data: any): OrderSetupChargesRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSetupChargesRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["discountedPrice"] = this.discountedPrice;
        return data;
    }
}

export interface IOrderSetupChargesRest {
    catalogueItemId?: number;
    name?: string;
    unitPrice?: number;
    discountedPrice?: number;
}

export class GetOrderWithPriceRequest implements IGetOrderWithPriceRequest {

    constructor(data?: IGetOrderWithPriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetOrderWithPriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderWithPriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetOrderWithPriceRequest {
}

export class GetRecommendedSamplingItemsResponse implements IGetRecommendedSamplingItemsResponse {
    samplingItems?: OrderSampleSamplingItemRest[];

    constructor(data?: IGetRecommendedSamplingItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["samplingItems"])) {
                this.samplingItems = [] as any;
                for (let item of _data["samplingItems"])
                    this.samplingItems!.push(OrderSampleSamplingItemRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecommendedSamplingItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendedSamplingItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.samplingItems)) {
            data["samplingItems"] = [];
            for (let item of this.samplingItems)
                data["samplingItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecommendedSamplingItemsResponse {
    samplingItems?: OrderSampleSamplingItemRest[];
}

export class GetRecommendedSamplingItemsRequest implements IGetRecommendedSamplingItemsRequest {

    constructor(data?: IGetRecommendedSamplingItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRecommendedSamplingItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendedSamplingItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRecommendedSamplingItemsRequest {
}

export class GetRecommendTestsResponse implements IGetRecommendTestsResponse {
    recommendedLabTests?: RecommendedTestRest[];

    constructor(data?: IGetRecommendTestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recommendedLabTests"])) {
                this.recommendedLabTests = [] as any;
                for (let item of _data["recommendedLabTests"])
                    this.recommendedLabTests!.push(RecommendedTestRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecommendTestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendTestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recommendedLabTests)) {
            data["recommendedLabTests"] = [];
            for (let item of this.recommendedLabTests)
                data["recommendedLabTests"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecommendTestsResponse {
    recommendedLabTests?: RecommendedTestRest[];
}

export class RecommendedTestRest implements IRecommendedTestRest {
    catalogueItemId?: number;
    name?: string;

    constructor(data?: IRecommendedTestRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RecommendedTestRest {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendedTestRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        return data;
    }
}

export interface IRecommendedTestRest {
    catalogueItemId?: number;
    name?: string;
}

export class GetRecommendedTestsRequest implements IGetRecommendedTestsRequest {

    constructor(data?: IGetRecommendedTestsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetRecommendedTestsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecommendedTestsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetRecommendedTestsRequest {
}

export class GetSampleTypesByCatalogueItemsResponse implements IGetSampleTypesByCatalogueItemsResponse {
    sampleTypes?: MyLabSampleTypeRest[];

    constructor(data?: IGetSampleTypesByCatalogueItemsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sampleTypes"])) {
                this.sampleTypes = [] as any;
                for (let item of _data["sampleTypes"])
                    this.sampleTypes!.push(MyLabSampleTypeRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSampleTypesByCatalogueItemsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesByCatalogueItemsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sampleTypes)) {
            data["sampleTypes"] = [];
            for (let item of this.sampleTypes)
                data["sampleTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSampleTypesByCatalogueItemsResponse {
    sampleTypes?: MyLabSampleTypeRest[];
}

export class GetSampleTypesByCatalogueItemsRequest implements IGetSampleTypesByCatalogueItemsRequest {
    catalogueItemIds!: number[];
    isOrderTemplate?: boolean;

    constructor(data?: IGetSampleTypesByCatalogueItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.catalogueItemIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["catalogueItemIds"])) {
                this.catalogueItemIds = [] as any;
                for (let item of _data["catalogueItemIds"])
                    this.catalogueItemIds!.push(item);
            }
            this.isOrderTemplate = _data["isOrderTemplate"];
        }
    }

    static fromJS(data: any): GetSampleTypesByCatalogueItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesByCatalogueItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.catalogueItemIds)) {
            data["catalogueItemIds"] = [];
            for (let item of this.catalogueItemIds)
                data["catalogueItemIds"].push(item);
        }
        data["isOrderTemplate"] = this.isOrderTemplate;
        return data;
    }
}

export interface IGetSampleTypesByCatalogueItemsRequest {
    catalogueItemIds: number[];
    isOrderTemplate?: boolean;
}

export class GetSampleTypesByOrganisationGroupsResponse implements IGetSampleTypesByOrganisationGroupsResponse {
    sampleTypes?: MyLabSampleTypeRest[];

    constructor(data?: IGetSampleTypesByOrganisationGroupsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sampleTypes"])) {
                this.sampleTypes = [] as any;
                for (let item of _data["sampleTypes"])
                    this.sampleTypes!.push(MyLabSampleTypeRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSampleTypesByOrganisationGroupsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesByOrganisationGroupsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sampleTypes)) {
            data["sampleTypes"] = [];
            for (let item of this.sampleTypes)
                data["sampleTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSampleTypesByOrganisationGroupsResponse {
    sampleTypes?: MyLabSampleTypeRest[];
}

export class GetSampleTypesByOrganisationGroupsRequest implements IGetSampleTypesByOrganisationGroupsRequest {
    organisationGroupIds!: number[];

    constructor(data?: IGetSampleTypesByOrganisationGroupsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organisationGroupIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organisationGroupIds"])) {
                this.organisationGroupIds = [] as any;
                for (let item of _data["organisationGroupIds"])
                    this.organisationGroupIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSampleTypesByOrganisationGroupsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesByOrganisationGroupsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organisationGroupIds)) {
            data["organisationGroupIds"] = [];
            for (let item of this.organisationGroupIds)
                data["organisationGroupIds"].push(item);
        }
        return data;
    }
}

export interface IGetSampleTypesByOrganisationGroupsRequest {
    organisationGroupIds: number[];
}

export class GetSampleTypesBySampleTypeCodesResponse implements IGetSampleTypesBySampleTypeCodesResponse {
    sampleTypes?: MyLabSampleTypeRest[];

    constructor(data?: IGetSampleTypesBySampleTypeCodesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sampleTypes"])) {
                this.sampleTypes = [] as any;
                for (let item of _data["sampleTypes"])
                    this.sampleTypes!.push(MyLabSampleTypeRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSampleTypesBySampleTypeCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesBySampleTypeCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sampleTypes)) {
            data["sampleTypes"] = [];
            for (let item of this.sampleTypes)
                data["sampleTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSampleTypesBySampleTypeCodesResponse {
    sampleTypes?: MyLabSampleTypeRest[];
}

export class GetSampleTypesBySampleTypeCodesRequest implements IGetSampleTypesBySampleTypeCodesRequest {
    sampleTypeCodes!: string[];

    constructor(data?: IGetSampleTypesBySampleTypeCodesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sampleTypeCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sampleTypeCodes"])) {
                this.sampleTypeCodes = [] as any;
                for (let item of _data["sampleTypeCodes"])
                    this.sampleTypeCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSampleTypesBySampleTypeCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSampleTypesBySampleTypeCodesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sampleTypeCodes)) {
            data["sampleTypeCodes"] = [];
            for (let item of this.sampleTypeCodes)
                data["sampleTypeCodes"].push(item);
        }
        return data;
    }
}

export interface IGetSampleTypesBySampleTypeCodesRequest {
    sampleTypeCodes: string[];
}

export class RemoveFavouriteLabTestRequest implements IRemoveFavouriteLabTestRequest {

    constructor(data?: IRemoveFavouriteLabTestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RemoveFavouriteLabTestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveFavouriteLabTestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRemoveFavouriteLabTestRequest {
}

export class SubmitOrderResponse implements ISubmitOrderResponse {
    /** The ID for the MyLab order */
    orderId?: string;
    /** The reserved Limbus ID for the submitted order */
    limbusOrderId?: number;
    /** Whether the submitted order is on hold */
    orderIsOnHold?: boolean;

    constructor(data?: ISubmitOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.limbusOrderId = _data["limbusOrderId"];
            this.orderIsOnHold = _data["orderIsOnHold"];
        }
    }

    static fromJS(data: any): SubmitOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["limbusOrderId"] = this.limbusOrderId;
        data["orderIsOnHold"] = this.orderIsOnHold;
        return data;
    }
}

export interface ISubmitOrderResponse {
    /** The ID for the MyLab order */
    orderId?: string;
    /** The reserved Limbus ID for the submitted order */
    limbusOrderId?: number;
    /** Whether the submitted order is on hold */
    orderIsOnHold?: boolean;
}

export class UpdateOrderResponse implements IUpdateOrderResponse {
    order?: MyLabOrderRest;

    constructor(data?: IUpdateOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"] ? MyLabOrderRest.fromJS(_data["order"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateOrderResponse {
    order?: MyLabOrderRest;
}

/** A request to update an OrderSample */
export class UpdateOrderRequest implements IUpdateOrderRequest {
    orderTemplateId?: string | undefined;
    orderSamples?: OrderSampleUpsertRest[];
    orderReference?: string;
    purchaseOrderNumber?: string;
    additionalReference?: string;
    additionalInformation?: string;
    recommendedSamplingItemsRequested?: boolean;
    isUrgent?: boolean;

    constructor(data?: IUpdateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplateId = _data["orderTemplateId"];
            if (Array.isArray(_data["orderSamples"])) {
                this.orderSamples = [] as any;
                for (let item of _data["orderSamples"])
                    this.orderSamples!.push(OrderSampleUpsertRest.fromJS(item));
            }
            this.orderReference = _data["orderReference"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.additionalReference = _data["additionalReference"];
            this.additionalInformation = _data["additionalInformation"];
            this.recommendedSamplingItemsRequested = _data["recommendedSamplingItemsRequested"];
            this.isUrgent = _data["isUrgent"];
        }
    }

    static fromJS(data: any): UpdateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplateId"] = this.orderTemplateId;
        if (Array.isArray(this.orderSamples)) {
            data["orderSamples"] = [];
            for (let item of this.orderSamples)
                data["orderSamples"].push(item.toJSON());
        }
        data["orderReference"] = this.orderReference;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["additionalReference"] = this.additionalReference;
        data["additionalInformation"] = this.additionalInformation;
        data["recommendedSamplingItemsRequested"] = this.recommendedSamplingItemsRequested;
        data["isUrgent"] = this.isUrgent;
        return data;
    }
}

/** A request to update an OrderSample */
export interface IUpdateOrderRequest {
    orderTemplateId?: string | undefined;
    orderSamples?: OrderSampleUpsertRest[];
    orderReference?: string;
    purchaseOrderNumber?: string;
    additionalReference?: string;
    additionalInformation?: string;
    recommendedSamplingItemsRequested?: boolean;
    isUrgent?: boolean;
}

export class OrderSampleUpsertRest implements IOrderSampleUpsertRest {
    orderSampleId?: string;
    orderTemplateSampleId?: number | undefined;
    orderTemplateLineId?: number | undefined;
    name?: string;
    clientSampleId?: string;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleTypeId?: number | undefined;
    analyticalTestsCatalogueItemIds?: number[];
    samplingItems?: OrderSampleSamplingItemUpsertRest[];
    containerCatalogueItemId?: number | undefined;
    compositeComponentSamples?: string[];
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    isComposited?: boolean;
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];

    constructor(data?: IOrderSampleUpsertRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSampleId = _data["orderSampleId"];
            this.orderTemplateSampleId = _data["orderTemplateSampleId"];
            this.orderTemplateLineId = _data["orderTemplateLineId"];
            this.name = _data["name"];
            this.clientSampleId = _data["clientSampleId"];
            this.sequence = _data["sequence"];
            this.sampleDateTime = _data["sampleDateTime"] ? new Date(_data["sampleDateTime"].toString()) : <any>undefined;
            this.sampleTypeId = _data["sampleTypeId"];
            if (Array.isArray(_data["analyticalTestsCatalogueItemIds"])) {
                this.analyticalTestsCatalogueItemIds = [] as any;
                for (let item of _data["analyticalTestsCatalogueItemIds"])
                    this.analyticalTestsCatalogueItemIds!.push(item);
            }
            if (Array.isArray(_data["samplingItems"])) {
                this.samplingItems = [] as any;
                for (let item of _data["samplingItems"])
                    this.samplingItems!.push(OrderSampleSamplingItemUpsertRest.fromJS(item));
            }
            this.containerCatalogueItemId = _data["containerCatalogueItemId"];
            if (Array.isArray(_data["compositeComponentSamples"])) {
                this.compositeComponentSamples = [] as any;
                for (let item of _data["compositeComponentSamples"])
                    this.compositeComponentSamples!.push(item);
            }
            this.isComposite = _data["isComposite"];
            this.sampleCompositeTypeId = _data["sampleCompositeTypeId"];
            this.isComposited = _data["isComposited"];
            if (Array.isArray(_data["organisationSampleIdentifiers"])) {
                this.organisationSampleIdentifiers = [] as any;
                for (let item of _data["organisationSampleIdentifiers"])
                    this.organisationSampleIdentifiers!.push(OrderSampleOrganisationSampleIdentifierRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderSampleUpsertRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleUpsertRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSampleId"] = this.orderSampleId;
        data["orderTemplateSampleId"] = this.orderTemplateSampleId;
        data["orderTemplateLineId"] = this.orderTemplateLineId;
        data["name"] = this.name;
        data["clientSampleId"] = this.clientSampleId;
        data["sequence"] = this.sequence;
        data["sampleDateTime"] = this.sampleDateTime ? this.sampleDateTime.toISOString() : <any>undefined;
        data["sampleTypeId"] = this.sampleTypeId;
        if (Array.isArray(this.analyticalTestsCatalogueItemIds)) {
            data["analyticalTestsCatalogueItemIds"] = [];
            for (let item of this.analyticalTestsCatalogueItemIds)
                data["analyticalTestsCatalogueItemIds"].push(item);
        }
        if (Array.isArray(this.samplingItems)) {
            data["samplingItems"] = [];
            for (let item of this.samplingItems)
                data["samplingItems"].push(item.toJSON());
        }
        data["containerCatalogueItemId"] = this.containerCatalogueItemId;
        if (Array.isArray(this.compositeComponentSamples)) {
            data["compositeComponentSamples"] = [];
            for (let item of this.compositeComponentSamples)
                data["compositeComponentSamples"].push(item);
        }
        data["isComposite"] = this.isComposite;
        data["sampleCompositeTypeId"] = this.sampleCompositeTypeId;
        data["isComposited"] = this.isComposited;
        if (Array.isArray(this.organisationSampleIdentifiers)) {
            data["organisationSampleIdentifiers"] = [];
            for (let item of this.organisationSampleIdentifiers)
                data["organisationSampleIdentifiers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderSampleUpsertRest {
    orderSampleId?: string;
    orderTemplateSampleId?: number | undefined;
    orderTemplateLineId?: number | undefined;
    name?: string;
    clientSampleId?: string;
    sequence?: number;
    sampleDateTime?: Date | undefined;
    sampleTypeId?: number | undefined;
    analyticalTestsCatalogueItemIds?: number[];
    samplingItems?: OrderSampleSamplingItemUpsertRest[];
    containerCatalogueItemId?: number | undefined;
    compositeComponentSamples?: string[];
    isComposite?: boolean;
    sampleCompositeTypeId?: number | undefined;
    isComposited?: boolean;
    organisationSampleIdentifiers?: OrderSampleOrganisationSampleIdentifierRest[];
}

export class OrderSampleSamplingItemUpsertRest implements IOrderSampleSamplingItemUpsertRest {
    catalogueItemId?: number;
    quantity?: number;

    constructor(data?: IOrderSampleSamplingItemUpsertRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): OrderSampleSamplingItemUpsertRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleSamplingItemUpsertRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IOrderSampleSamplingItemUpsertRest {
    catalogueItemId?: number;
    quantity?: number;
}

export class UpdateOrderSampleParametersResponse implements IUpdateOrderSampleParametersResponse {
    orderSampleParameters?: OrderSampleParameterRest[];

    constructor(data?: IUpdateOrderSampleParametersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSampleParameters"])) {
                this.orderSampleParameters = [] as any;
                for (let item of _data["orderSampleParameters"])
                    this.orderSampleParameters!.push(OrderSampleParameterRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderSampleParametersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderSampleParametersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSampleParameters)) {
            data["orderSampleParameters"] = [];
            for (let item of this.orderSampleParameters)
                data["orderSampleParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateOrderSampleParametersResponse {
    orderSampleParameters?: OrderSampleParameterRest[];
}

/** A request to update an OrderSample */
export class UpdateOrderSampleParametersRequest implements IUpdateOrderSampleParametersRequest {
    orderSampleParameters!: OrderSampleParameterUpsertRest[];

    constructor(data?: IUpdateOrderSampleParametersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.orderSampleParameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["orderSampleParameters"])) {
                this.orderSampleParameters = [] as any;
                for (let item of _data["orderSampleParameters"])
                    this.orderSampleParameters!.push(OrderSampleParameterUpsertRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateOrderSampleParametersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrderSampleParametersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderSampleParameters)) {
            data["orderSampleParameters"] = [];
            for (let item of this.orderSampleParameters)
                data["orderSampleParameters"].push(item.toJSON());
        }
        return data;
    }
}

/** A request to update an OrderSample */
export interface IUpdateOrderSampleParametersRequest {
    orderSampleParameters: OrderSampleParameterUpsertRest[];
}

export class OrderSampleParameterUpsertRest implements IOrderSampleParameterUpsertRest {
    orderSampleParameterId?: string;
    value?: string;

    constructor(data?: IOrderSampleParameterUpsertRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderSampleParameterId = _data["orderSampleParameterId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): OrderSampleParameterUpsertRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderSampleParameterUpsertRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderSampleParameterId"] = this.orderSampleParameterId;
        data["value"] = this.value;
        return data;
    }
}

export interface IOrderSampleParameterUpsertRest {
    orderSampleParameterId?: string;
    value?: string;
}

export class GetCatalogueItemIdByCodeResponse implements IGetCatalogueItemIdByCodeResponse {
    catalogueItemId?: number;
    name?: string;

    constructor(data?: IGetCatalogueItemIdByCodeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogueItemId = _data["catalogueItemId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetCatalogueItemIdByCodeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogueItemIdByCodeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogueItemId"] = this.catalogueItemId;
        data["name"] = this.name;
        return data;
    }
}

export interface IGetCatalogueItemIdByCodeResponse {
    catalogueItemId?: number;
    name?: string;
}

export class GetCatalogueItemIdByCodeRequest implements IGetCatalogueItemIdByCodeRequest {

    constructor(data?: IGetCatalogueItemIdByCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetCatalogueItemIdByCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCatalogueItemIdByCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetCatalogueItemIdByCodeRequest {
}

export class SimulatorAccessSummaryResponse implements ISimulatorAccessSummaryResponse {
    jobNumber?: number;
    evaluatedAt?: Date;
    effectiveConfigurationOrganisationId?: number;
    configurationSource?: ConfigurationSource;
    job?: SimulatorJobResponse;
    groups?: AccessGroup[];

    constructor(data?: ISimulatorAccessSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.evaluatedAt = _data["evaluatedAt"] ? new Date(_data["evaluatedAt"].toString()) : <any>undefined;
            this.effectiveConfigurationOrganisationId = _data["effectiveConfigurationOrganisationId"];
            this.configurationSource = _data["configurationSource"] ? ConfigurationSource.fromJS(_data["configurationSource"]) : <any>undefined;
            this.job = _data["job"] ? SimulatorJobResponse.fromJS(_data["job"]) : <any>undefined;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(AccessGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimulatorAccessSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorAccessSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["evaluatedAt"] = this.evaluatedAt ? this.evaluatedAt.toISOString() : <any>undefined;
        data["effectiveConfigurationOrganisationId"] = this.effectiveConfigurationOrganisationId;
        data["configurationSource"] = this.configurationSource ? this.configurationSource.toJSON() : <any>undefined;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISimulatorAccessSummaryResponse {
    jobNumber?: number;
    evaluatedAt?: Date;
    effectiveConfigurationOrganisationId?: number;
    configurationSource?: ConfigurationSource;
    job?: SimulatorJobResponse;
    groups?: AccessGroup[];
}

export class ConfigurationSource implements IConfigurationSource {
    requestedOrganisationId?: number;
    sourceOrganisationId?: number | undefined;
    sourceOrganisationName?: string | undefined;
    sourceType?: ConfigurationSourceType;

    constructor(data?: IConfigurationSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestedOrganisationId = _data["requestedOrganisationId"];
            this.sourceOrganisationId = _data["sourceOrganisationId"];
            this.sourceOrganisationName = _data["sourceOrganisationName"];
            this.sourceType = _data["sourceType"];
        }
    }

    static fromJS(data: any): ConfigurationSource {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedOrganisationId"] = this.requestedOrganisationId;
        data["sourceOrganisationId"] = this.sourceOrganisationId;
        data["sourceOrganisationName"] = this.sourceOrganisationName;
        data["sourceType"] = this.sourceType;
        return data;
    }
}

export interface IConfigurationSource {
    requestedOrganisationId?: number;
    sourceOrganisationId?: number | undefined;
    sourceOrganisationName?: string | undefined;
    sourceType?: ConfigurationSourceType;
}

export enum ConfigurationSourceType {
    Explicit = "Explicit",
    Inherited = "Inherited",
    SystemDefault = "SystemDefault",
}

export class SimulatorJobResponse implements ISimulatorJobResponse {
    jobNumber?: number;
    lifecycleAt?: Date;
    roles?: SimulatorRoles;
    effectiveConfiguration?: OrganisationConfigurationProviderResult;
    configurationSource?: ConfigurationSource;

    constructor(data?: ISimulatorJobResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
            this.lifecycleAt = _data["lifecycleAt"] ? new Date(_data["lifecycleAt"].toString()) : <any>undefined;
            this.roles = _data["roles"] ? SimulatorRoles.fromJS(_data["roles"]) : <any>undefined;
            this.effectiveConfiguration = _data["effectiveConfiguration"] ? OrganisationConfigurationProviderResult.fromJS(_data["effectiveConfiguration"]) : <any>undefined;
            this.configurationSource = _data["configurationSource"] ? ConfigurationSource.fromJS(_data["configurationSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimulatorJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorJobResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        data["lifecycleAt"] = this.lifecycleAt ? this.lifecycleAt.toISOString() : <any>undefined;
        data["roles"] = this.roles ? this.roles.toJSON() : <any>undefined;
        data["effectiveConfiguration"] = this.effectiveConfiguration ? this.effectiveConfiguration.toJSON() : <any>undefined;
        data["configurationSource"] = this.configurationSource ? this.configurationSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISimulatorJobResponse {
    jobNumber?: number;
    lifecycleAt?: Date;
    roles?: SimulatorRoles;
    effectiveConfiguration?: OrganisationConfigurationProviderResult;
    configurationSource?: ConfigurationSource;
}

export class SimulatorRoles implements ISimulatorRoles {
    primary?: SimulatorRole;
    submitter?: SimulatorRole | undefined;
    chargeTo?: SimulatorRole | undefined;
    client?: SimulatorRole | undefined;

    constructor(data?: ISimulatorRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primary = _data["primary"] ? SimulatorRole.fromJS(_data["primary"]) : <any>undefined;
            this.submitter = _data["submitter"] ? SimulatorRole.fromJS(_data["submitter"]) : <any>undefined;
            this.chargeTo = _data["chargeTo"] ? SimulatorRole.fromJS(_data["chargeTo"]) : <any>undefined;
            this.client = _data["client"] ? SimulatorRole.fromJS(_data["client"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SimulatorRoles {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primary"] = this.primary ? this.primary.toJSON() : <any>undefined;
        data["submitter"] = this.submitter ? this.submitter.toJSON() : <any>undefined;
        data["chargeTo"] = this.chargeTo ? this.chargeTo.toJSON() : <any>undefined;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISimulatorRoles {
    primary?: SimulatorRole;
    submitter?: SimulatorRole | undefined;
    chargeTo?: SimulatorRole | undefined;
    client?: SimulatorRole | undefined;
}

export class SimulatorRole implements ISimulatorRole {
    role?: RoleKind;
    holderType?: string;
    labsysContactId?: number | undefined;
    contactId?: number | undefined;
    organisationId?: number | undefined;
    displayName?: string | undefined;
    parentOrganisationId?: number | undefined;
    isActive?: boolean | undefined;

    constructor(data?: ISimulatorRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.holderType = _data["holderType"];
            this.labsysContactId = _data["labsysContactId"];
            this.contactId = _data["contactId"];
            this.organisationId = _data["organisationId"];
            this.displayName = _data["displayName"];
            this.parentOrganisationId = _data["parentOrganisationId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SimulatorRole {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["holderType"] = this.holderType;
        data["labsysContactId"] = this.labsysContactId;
        data["contactId"] = this.contactId;
        data["organisationId"] = this.organisationId;
        data["displayName"] = this.displayName;
        data["parentOrganisationId"] = this.parentOrganisationId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ISimulatorRole {
    role?: RoleKind;
    holderType?: string;
    labsysContactId?: number | undefined;
    contactId?: number | undefined;
    organisationId?: number | undefined;
    displayName?: string | undefined;
    parentOrganisationId?: number | undefined;
    isActive?: boolean | undefined;
}

export enum RoleKind {
    Primary = "Primary",
    Submitter = "Submitter",
    ChargeTo = "ChargeTo",
    Client = "Client",
}

export class OrganisationConfigurationProviderResult implements IOrganisationConfigurationProviderResult {
    /** Gets whether sampling supplies can be ordered for the organisation. */
    canOrderSamplingSupplies?: boolean;
    /** Gets whether laboratory tests can be ordered for the organisation. */
    canOrderLabTests?: boolean;
    /** Gets whether jobs can be shared between branches. */
    jobsCanCrossBranchShare?: boolean;
    /** Gets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets whether Submitters can view jobs they submitted. */
    submitterCanViewJobs?: boolean;
    /** Gets whether the Charge To contact can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets whether the Charge To contact can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets whether the Charge To contact can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    /** Gets the organisation whose explicit row supplied the effective configuration, or null for system defaults. */
    effectiveConfigurationLimbusOrganisationId?: number | undefined;
    /** Gets whether the effective values came from system defaults. */
    usesSystemDefaults?: boolean;

    constructor(data?: IOrganisationConfigurationProviderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canOrderSamplingSupplies = _data["canOrderSamplingSupplies"];
            this.canOrderLabTests = _data["canOrderLabTests"];
            this.jobsCanCrossBranchShare = _data["jobsCanCrossBranchShare"];
            this.primaryAffiliateCanViewJobs = _data["primaryAffiliateCanViewJobs"];
            this.primaryAffiliateCanViewResults = _data["primaryAffiliateCanViewResults"];
            this.submitterCanViewJobs = _data["submitterCanViewJobs"];
            this.chargeToCanViewJobs = _data["chargeToCanViewJobs"];
            this.chargeToCanViewResults = _data["chargeToCanViewResults"];
            this.chargeToCanViewInvoices = _data["chargeToCanViewInvoices"];
            this.chargeToAffiliateCanViewJobs = _data["chargeToAffiliateCanViewJobs"];
            this.chargeToAffiliateCanViewResults = _data["chargeToAffiliateCanViewResults"];
            this.chargeToAffiliateCanViewInvoices = _data["chargeToAffiliateCanViewInvoices"];
            this.effectiveConfigurationLimbusOrganisationId = _data["effectiveConfigurationLimbusOrganisationId"];
            this.usesSystemDefaults = _data["usesSystemDefaults"];
        }
    }

    static fromJS(data: any): OrganisationConfigurationProviderResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationConfigurationProviderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canOrderSamplingSupplies"] = this.canOrderSamplingSupplies;
        data["canOrderLabTests"] = this.canOrderLabTests;
        data["jobsCanCrossBranchShare"] = this.jobsCanCrossBranchShare;
        data["primaryAffiliateCanViewJobs"] = this.primaryAffiliateCanViewJobs;
        data["primaryAffiliateCanViewResults"] = this.primaryAffiliateCanViewResults;
        data["submitterCanViewJobs"] = this.submitterCanViewJobs;
        data["chargeToCanViewJobs"] = this.chargeToCanViewJobs;
        data["chargeToCanViewResults"] = this.chargeToCanViewResults;
        data["chargeToCanViewInvoices"] = this.chargeToCanViewInvoices;
        data["chargeToAffiliateCanViewJobs"] = this.chargeToAffiliateCanViewJobs;
        data["chargeToAffiliateCanViewResults"] = this.chargeToAffiliateCanViewResults;
        data["chargeToAffiliateCanViewInvoices"] = this.chargeToAffiliateCanViewInvoices;
        data["effectiveConfigurationLimbusOrganisationId"] = this.effectiveConfigurationLimbusOrganisationId;
        data["usesSystemDefaults"] = this.usesSystemDefaults;
        return data;
    }
}

export interface IOrganisationConfigurationProviderResult {
    /** Gets whether sampling supplies can be ordered for the organisation. */
    canOrderSamplingSupplies?: boolean;
    /** Gets whether laboratory tests can be ordered for the organisation. */
    canOrderLabTests?: boolean;
    /** Gets whether jobs can be shared between branches. */
    jobsCanCrossBranchShare?: boolean;
    /** Gets whether Primary Contact affiliates can view jobs. */
    primaryAffiliateCanViewJobs?: boolean;
    /** Gets whether Primary Contact affiliates can view results. */
    primaryAffiliateCanViewResults?: boolean;
    /** Gets whether Submitters can view jobs they submitted. */
    submitterCanViewJobs?: boolean;
    /** Gets whether the Charge To contact can view jobs. */
    chargeToCanViewJobs?: boolean;
    /** Gets whether the Charge To contact can view results. */
    chargeToCanViewResults?: boolean;
    /** Gets whether the Charge To contact can view invoices. */
    chargeToCanViewInvoices?: boolean;
    /** Gets whether Charge To affiliates can view jobs. */
    chargeToAffiliateCanViewJobs?: boolean;
    /** Gets whether Charge To affiliates can view results. */
    chargeToAffiliateCanViewResults?: boolean;
    /** Gets whether Charge To affiliates can view invoices. */
    chargeToAffiliateCanViewInvoices?: boolean;
    /** Gets the organisation whose explicit row supplied the effective configuration, or null for system defaults. */
    effectiveConfigurationLimbusOrganisationId?: number | undefined;
    /** Gets whether the effective values came from system defaults. */
    usesSystemDefaults?: boolean;
}

export class AccessGroup implements IAccessGroup {
    reason?: JobAccessReason;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    totalContacts?: number;
    canViewJob?: boolean;
    canViewResults?: boolean;
    canViewInvoices?: boolean;
    contacts?: AccessContact[];

    constructor(data?: IAccessGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.totalContacts = _data["totalContacts"];
            this.canViewJob = _data["canViewJob"];
            this.canViewResults = _data["canViewResults"];
            this.canViewInvoices = _data["canViewInvoices"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(AccessContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessGroup {
        data = typeof data === 'object' ? data : {};
        let result = new AccessGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["totalContacts"] = this.totalContacts;
        data["canViewJob"] = this.canViewJob;
        data["canViewResults"] = this.canViewResults;
        data["canViewInvoices"] = this.canViewInvoices;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccessGroup {
    reason?: JobAccessReason;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    totalContacts?: number;
    canViewJob?: boolean;
    canViewResults?: boolean;
    canViewInvoices?: boolean;
    contacts?: AccessContact[];
}

export enum JobAccessReason {
    PrimaryContact = "PrimaryContact",
    PrimaryAffiliateAllowed = "PrimaryAffiliateAllowed",
    SubmitterAllowed = "SubmitterAllowed",
    ChargeToAllowed = "ChargeToAllowed",
    ChargeToAffiliateAllowed = "ChargeToAffiliateAllowed",
    CrossBranchAllowed = "CrossBranchAllowed",
    MasterSlaveAllowed = "MasterSlaveAllowed",
    ViewerIdentityMissing = "ViewerIdentityMissing",
    ViewerContactInactive = "ViewerContactInactive",
    LifecycleMissing = "LifecycleMissing",
    ConfigurationSourceMissing = "ConfigurationSourceMissing",
    HiddenByPrimaryContact = "HiddenByPrimaryContact",
    HiddenFromChargeTo = "HiddenFromChargeTo",
    SlaveHideMyOrders = "SlaveHideMyOrders",
    NoMatchingGrant = "NoMatchingGrant",
    WrongLifecyclePeriod = "WrongLifecyclePeriod",
    RelationshipFactsMissing = "RelationshipFactsMissing",
    ParentOrganisationAllowed = "ParentOrganisationAllowed",
}

export class AccessContact implements IAccessContact {
    contactId?: number;
    labsysContactId?: number;
    displayName?: string;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    hasMyLabAccess?: boolean;
    canViewJob?: boolean;
    canViewResults?: boolean;
    canViewInvoices?: boolean;
    matchedRoles?: RoleKind[];
    matchedReasons?: JobAccessReason[];

    constructor(data?: IAccessContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactId = _data["contactId"];
            this.labsysContactId = _data["labsysContactId"];
            this.displayName = _data["displayName"];
            this.organisationId = _data["organisationId"];
            this.organisationName = _data["organisationName"];
            this.hasMyLabAccess = _data["hasMyLabAccess"];
            this.canViewJob = _data["canViewJob"];
            this.canViewResults = _data["canViewResults"];
            this.canViewInvoices = _data["canViewInvoices"];
            if (Array.isArray(_data["matchedRoles"])) {
                this.matchedRoles = [] as any;
                for (let item of _data["matchedRoles"])
                    this.matchedRoles!.push(item);
            }
            if (Array.isArray(_data["matchedReasons"])) {
                this.matchedReasons = [] as any;
                for (let item of _data["matchedReasons"])
                    this.matchedReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): AccessContact {
        data = typeof data === 'object' ? data : {};
        let result = new AccessContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactId"] = this.contactId;
        data["labsysContactId"] = this.labsysContactId;
        data["displayName"] = this.displayName;
        data["organisationId"] = this.organisationId;
        data["organisationName"] = this.organisationName;
        data["hasMyLabAccess"] = this.hasMyLabAccess;
        data["canViewJob"] = this.canViewJob;
        data["canViewResults"] = this.canViewResults;
        data["canViewInvoices"] = this.canViewInvoices;
        if (Array.isArray(this.matchedRoles)) {
            data["matchedRoles"] = [];
            for (let item of this.matchedRoles)
                data["matchedRoles"].push(item);
        }
        if (Array.isArray(this.matchedReasons)) {
            data["matchedReasons"] = [];
            for (let item of this.matchedReasons)
                data["matchedReasons"].push(item);
        }
        return data;
    }
}

export interface IAccessContact {
    contactId?: number;
    labsysContactId?: number;
    displayName?: string;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    hasMyLabAccess?: boolean;
    canViewJob?: boolean;
    canViewResults?: boolean;
    canViewInvoices?: boolean;
    matchedRoles?: RoleKind[];
    matchedReasons?: JobAccessReason[];
}

export class SimulatorAccessSummaryRequest implements ISimulatorAccessSummaryRequest {
    jobNumber?: number;

    constructor(data?: ISimulatorAccessSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobNumber = _data["jobNumber"];
        }
    }

    static fromJS(data: any): SimulatorAccessSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorAccessSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobNumber"] = this.jobNumber;
        return data;
    }
}

export interface ISimulatorAccessSummaryRequest {
    jobNumber?: number;
}

export class GetSimulatorJobRequest implements IGetSimulatorJobRequest {

    constructor(data?: IGetSimulatorJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSimulatorJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSimulatorJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetSimulatorJobRequest {
}

export class LogEventsRequest implements ILogEventsRequest {
    events?: EventRest[];

    constructor(data?: ILogEventsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(EventRest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LogEventsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LogEventsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILogEventsRequest {
    events?: EventRest[];
}

export class EventRest implements IEventRest {
    eventId?: string;
    sessionId?: string;
    eventType?: string;
    data?: any;
    occurredAt?: Date;

    constructor(data?: IEventRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.sessionId = _data["sessionId"];
            this.eventType = _data["eventType"];
            this.data = _data["data"];
            this.occurredAt = _data["occurredAt"] ? new Date(_data["occurredAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EventRest {
        data = typeof data === 'object' ? data : {};
        let result = new EventRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["sessionId"] = this.sessionId;
        data["eventType"] = this.eventType;
        data["data"] = this.data;
        data["occurredAt"] = this.occurredAt ? this.occurredAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEventRest {
    eventId?: string;
    sessionId?: string;
    eventType?: string;
    data?: any;
    occurredAt?: Date;
}

/** Response model for password change */
export class ChangePasswordResponse implements IChangePasswordResponse {
    message?: string;

    constructor(data?: IChangePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ChangePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

/** Response model for password change */
export interface IChangePasswordResponse {
    message?: string;
}

/** Request model for changing password */
export class ChangePasswordRequest implements IChangePasswordRequest {
    /** Current password for verification */
    oldPassword!: string;
    /** New password to set */
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.oldPassword = "CurrentPass123!";
            this.newPassword = "NewSecurePass123!";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"] !== undefined ? _data["oldPassword"] : "CurrentPass123!";
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : "NewSecurePass123!";
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

/** Request model for changing password */
export interface IChangePasswordRequest {
    /** Current password for verification */
    oldPassword: string;
    /** New password to set */
    newPassword: string;
}

/** Response model for login token containing authentication tokens. */
export class LoginResponse implements ILoginResponse {
    /** The access token for API authentication */
    access_token?: string;
    /** The ID token containing user identity information */
    id_token?: string;
    /** The scope of the granted permissions */
    scope?: string;
    /** Token expiration time in seconds */
    expires_in?: number;
    /** The type of token (typically "Bearer") */
    token_type?: string;
    /** The identity provider used for authentication. */
    provider?: string;

    constructor(data?: ILoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access_token = _data["access_token"];
            this.id_token = _data["id_token"];
            this.scope = _data["scope"];
            this.expires_in = _data["expires_in"];
            this.token_type = _data["token_type"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): LoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token;
        data["id_token"] = this.id_token;
        data["scope"] = this.scope;
        data["expires_in"] = this.expires_in;
        data["token_type"] = this.token_type;
        data["provider"] = this.provider;
        return data;
    }
}

/** Response model for login token containing authentication tokens. */
export interface ILoginResponse {
    /** The access token for API authentication */
    access_token?: string;
    /** The ID token containing user identity information */
    id_token?: string;
    /** The scope of the granted permissions */
    scope?: string;
    /** Token expiration time in seconds */
    expires_in?: number;
    /** The type of token (typically "Bearer") */
    token_type?: string;
    /** The identity provider used for authentication. */
    provider?: string;
}

/** Request model for user login */
export class LoginRequest implements ILoginRequest {
    /** User's email address */
    email!: string;
    /** User's password */
    password!: string;
    /** Platform from which the login is being performed (Web or Mobile). Defaults to Web if not provided. */
    platform?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.email = "john.doe@example.com";
            this.password = "SecurePass123!";
            this.platform = "Web";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : "john.doe@example.com";
            this.password = _data["password"] !== undefined ? _data["password"] : "SecurePass123!";
            this.platform = _data["platform"] !== undefined ? _data["platform"] : "Web";
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["platform"] = this.platform;
        return data;
    }
}

/** Request model for user login */
export interface ILoginRequest {
    /** User's email address */
    email: string;
    /** User's password */
    password: string;
    /** Platform from which the login is being performed (Web or Mobile). Defaults to Web if not provided. */
    platform?: string | undefined;
}

/** Response model for user registration */
export class RegisterResponse implements IRegisterResponse {
    message?: string;
    userId?: string;

    constructor(data?: IRegisterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): RegisterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["userId"] = this.userId;
        return data;
    }
}

/** Response model for user registration */
export interface IRegisterResponse {
    message?: string;
    userId?: string;
}

/** Request model for user registration */
export class RegisterRequest implements IRegisterRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    company?: string | undefined;
    mobilePhone?: string | undefined;
    homePhone?: string | undefined;
    physicalAddress!: AddressRegistrationRest;
    postalAddress!: AddressRegistrationRest;
    portalTcAccepted?: boolean;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firstName = "John";
            this.lastName = "Doe";
            this.email = "john.doe@example.com";
            this.password = "SecurePass123!";
            this.company = "Hill Laboratories";
            this.mobilePhone = "021234567";
            this.homePhone = "094567890";
            this.physicalAddress = new AddressRegistrationRest();
            this.postalAddress = new AddressRegistrationRest();
            this.portalTcAccepted = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : "John";
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : "Doe";
            this.email = _data["email"] !== undefined ? _data["email"] : "john.doe@example.com";
            this.password = _data["password"] !== undefined ? _data["password"] : "SecurePass123!";
            this.company = _data["company"] !== undefined ? _data["company"] : "Hill Laboratories";
            this.mobilePhone = _data["mobilePhone"] !== undefined ? _data["mobilePhone"] : "021234567";
            this.homePhone = _data["homePhone"] !== undefined ? _data["homePhone"] : "094567890";
            this.physicalAddress = _data["physicalAddress"] ? AddressRegistrationRest.fromJS(_data["physicalAddress"]) : new AddressRegistrationRest();
            this.postalAddress = _data["postalAddress"] ? AddressRegistrationRest.fromJS(_data["postalAddress"]) : new AddressRegistrationRest();
            this.portalTcAccepted = _data["portalTcAccepted"] !== undefined ? _data["portalTcAccepted"] : true;
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["company"] = this.company;
        data["mobilePhone"] = this.mobilePhone;
        data["homePhone"] = this.homePhone;
        data["physicalAddress"] = this.physicalAddress ? this.physicalAddress.toJSON() : <any>undefined;
        data["postalAddress"] = this.postalAddress ? this.postalAddress.toJSON() : <any>undefined;
        data["portalTcAccepted"] = this.portalTcAccepted;
        return data;
    }
}

/** Request model for user registration */
export interface IRegisterRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    company?: string | undefined;
    mobilePhone?: string | undefined;
    homePhone?: string | undefined;
    physicalAddress: AddressRegistrationRest;
    postalAddress: AddressRegistrationRest;
    portalTcAccepted?: boolean;
}

/** Address information for registration */
export class AddressRegistrationRest implements IAddressRegistrationRest {
    line1!: string;
    line2?: string | undefined;
    townOrCity!: string;
    province?: string | undefined;
    postCode!: string;
    country?: string | undefined;
    nzPostDpId?: number;

    constructor(data?: IAddressRegistrationRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.line1 = "123 Main Street";
            this.line2 = "Unit 1";
            this.townOrCity = "Auckland";
            this.province = "Auckland";
            this.postCode = "1010";
            this.country = "New Zealand";
            this.nzPostDpId = 12345;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line1 = _data["line1"] !== undefined ? _data["line1"] : "123 Main Street";
            this.line2 = _data["line2"] !== undefined ? _data["line2"] : "Unit 1";
            this.townOrCity = _data["townOrCity"] !== undefined ? _data["townOrCity"] : "Auckland";
            this.province = _data["province"] !== undefined ? _data["province"] : "Auckland";
            this.postCode = _data["postCode"] !== undefined ? _data["postCode"] : "1010";
            this.country = _data["country"] !== undefined ? _data["country"] : "New Zealand";
            this.nzPostDpId = _data["nzPostDpId"] !== undefined ? _data["nzPostDpId"] : 12345;
        }
    }

    static fromJS(data: any): AddressRegistrationRest {
        data = typeof data === 'object' ? data : {};
        let result = new AddressRegistrationRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line1"] = this.line1;
        data["line2"] = this.line2;
        data["townOrCity"] = this.townOrCity;
        data["province"] = this.province;
        data["postCode"] = this.postCode;
        data["country"] = this.country;
        data["nzPostDpId"] = this.nzPostDpId;
        return data;
    }
}

/** Address information for registration */
export interface IAddressRegistrationRest {
    line1: string;
    line2?: string | undefined;
    townOrCity: string;
    province?: string | undefined;
    postCode: string;
    country?: string | undefined;
    nzPostDpId?: number;
}

/** Response model for resending verification email */
export class ResendVerificationEmailResponse implements IResendVerificationEmailResponse {
    message?: string;

    constructor(data?: IResendVerificationEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResendVerificationEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

/** Response model for resending verification email */
export interface IResendVerificationEmailResponse {
    message?: string;
}

/** Request model for resending verification email */
export class ResendVerificationEmailRequest implements IResendVerificationEmailRequest {
    /** Email address to send verification email to */
    email!: string;

    constructor(data?: IResendVerificationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.email = "john.doe@example.com";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : "john.doe@example.com";
        }
    }

    static fromJS(data: any): ResendVerificationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendVerificationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

/** Request model for resending verification email */
export interface IResendVerificationEmailRequest {
    /** Email address to send verification email to */
    email: string;
}

/** Response model for password reset */
export class ResetPasswordResponse implements IResetPasswordResponse {
    /** Success message */
    message?: string;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

/** Response model for password reset */
export interface IResetPasswordResponse {
    /** Success message */
    message?: string;
}

/** Request model for password reset */
export class ResetPasswordRequest implements IResetPasswordRequest {
    /** Email address to send password reset instructions to */
    email!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.email = "john.doe@example.com";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : "john.doe@example.com";
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

/** Request model for password reset */
export interface IResetPasswordRequest {
    /** Email address to send password reset instructions to */
    email: string;
}

/** Response model for setting password */
export class SetPasswordResponse implements ISetPasswordResponse {
    message?: string;

    constructor(data?: ISetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

/** Response model for setting password */
export interface ISetPasswordResponse {
    message?: string;
}

/** Request model for setting password */
export class SetPasswordRequest implements ISetPasswordRequest {
    /** New password */
    newPassword!: string;
    /** Reset token received via email */
    token!: string;

    constructor(data?: ISetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.newPassword = "newPassword123!";
            this.token = "AbCdEfGhIjKlMnOpQrStUvWxYz1234567890AbCdEfGhIjKlMnOpQrStUvWxYz12";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"] !== undefined ? _data["newPassword"] : "newPassword123!";
            this.token = _data["token"] !== undefined ? _data["token"] : "AbCdEfGhIjKlMnOpQrStUvWxYz1234567890AbCdEfGhIjKlMnOpQrStUvWxYz12";
        }
    }

    static fromJS(data: any): SetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["token"] = this.token;
        return data;
    }
}

/** Request model for setting password */
export interface ISetPasswordRequest {
    /** New password */
    newPassword: string;
    /** Reset token received via email */
    token: string;
}

/** Response model for email verification */
export class VerifyEmailResponse implements IVerifyEmailResponse {
    /** Success message */
    message?: string;
    /** Email address that was verified */
    email?: string;
    /** Timestamp when the email was verified */
    verifiedAt?: Date;

    constructor(data?: IVerifyEmailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.email = _data["email"];
            this.verifiedAt = _data["verifiedAt"] ? new Date(_data["verifiedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VerifyEmailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["email"] = this.email;
        data["verifiedAt"] = this.verifiedAt ? this.verifiedAt.toISOString() : <any>undefined;
        return data;
    }
}

/** Response model for email verification */
export interface IVerifyEmailResponse {
    /** Success message */
    message?: string;
    /** Email address that was verified */
    email?: string;
    /** Timestamp when the email was verified */
    verifiedAt?: Date;
}

/** Request model for email verification */
export class VerifyEmailRequest implements IVerifyEmailRequest {
    /** Verification token sent to the email address */
    token!: string;

    constructor(data?: IVerifyEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.token = "abc123def456ghi789jkl012mno345pqr678stu901vwx234yzA567BCD890EFG123";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] !== undefined ? _data["token"] : "abc123def456ghi789jkl012mno345pqr678stu901vwx234yzA567BCD890EFG123";
        }
    }

    static fromJS(data: any): VerifyEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data;
    }
}

/** Request model for email verification */
export interface IVerifyEmailRequest {
    /** Verification token sent to the email address */
    token: string;
}

export class GetConfigResponse implements IGetConfigResponse {
    labOrdersOrderTemplateSummaries?: OrderTemplateSummaryRest[];
    labOrdersAllowClientSampleId?: boolean;
    labOrdersUseSampleIdentifiersAsSampleName?: boolean;
    labOrdersSampleIdentifierSeparator?: string;
    organisationSampleIdentifiers?: OrganisationSampleIdentifierRest[];
    labOrdersAllowUrgent?: boolean;
    canOrderSamplingSupplies?: boolean;
    canOrderLabTests?: boolean;
    jobsCanCrossBranchShare?: boolean;

    constructor(data?: IGetConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["labOrdersOrderTemplateSummaries"])) {
                this.labOrdersOrderTemplateSummaries = [] as any;
                for (let item of _data["labOrdersOrderTemplateSummaries"])
                    this.labOrdersOrderTemplateSummaries!.push(OrderTemplateSummaryRest.fromJS(item));
            }
            this.labOrdersAllowClientSampleId = _data["labOrdersAllowClientSampleId"];
            this.labOrdersUseSampleIdentifiersAsSampleName = _data["labOrdersUseSampleIdentifiersAsSampleName"];
            this.labOrdersSampleIdentifierSeparator = _data["labOrdersSampleIdentifierSeparator"];
            if (Array.isArray(_data["organisationSampleIdentifiers"])) {
                this.organisationSampleIdentifiers = [] as any;
                for (let item of _data["organisationSampleIdentifiers"])
                    this.organisationSampleIdentifiers!.push(OrganisationSampleIdentifierRest.fromJS(item));
            }
            this.labOrdersAllowUrgent = _data["labOrdersAllowUrgent"];
            this.canOrderSamplingSupplies = _data["canOrderSamplingSupplies"];
            this.canOrderLabTests = _data["canOrderLabTests"];
            this.jobsCanCrossBranchShare = _data["jobsCanCrossBranchShare"];
        }
    }

    static fromJS(data: any): GetConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.labOrdersOrderTemplateSummaries)) {
            data["labOrdersOrderTemplateSummaries"] = [];
            for (let item of this.labOrdersOrderTemplateSummaries)
                data["labOrdersOrderTemplateSummaries"].push(item.toJSON());
        }
        data["labOrdersAllowClientSampleId"] = this.labOrdersAllowClientSampleId;
        data["labOrdersUseSampleIdentifiersAsSampleName"] = this.labOrdersUseSampleIdentifiersAsSampleName;
        data["labOrdersSampleIdentifierSeparator"] = this.labOrdersSampleIdentifierSeparator;
        if (Array.isArray(this.organisationSampleIdentifiers)) {
            data["organisationSampleIdentifiers"] = [];
            for (let item of this.organisationSampleIdentifiers)
                data["organisationSampleIdentifiers"].push(item.toJSON());
        }
        data["labOrdersAllowUrgent"] = this.labOrdersAllowUrgent;
        data["canOrderSamplingSupplies"] = this.canOrderSamplingSupplies;
        data["canOrderLabTests"] = this.canOrderLabTests;
        data["jobsCanCrossBranchShare"] = this.jobsCanCrossBranchShare;
        return data;
    }
}

export interface IGetConfigResponse {
    labOrdersOrderTemplateSummaries?: OrderTemplateSummaryRest[];
    labOrdersAllowClientSampleId?: boolean;
    labOrdersUseSampleIdentifiersAsSampleName?: boolean;
    labOrdersSampleIdentifierSeparator?: string;
    organisationSampleIdentifiers?: OrganisationSampleIdentifierRest[];
    labOrdersAllowUrgent?: boolean;
    canOrderSamplingSupplies?: boolean;
    canOrderLabTests?: boolean;
    jobsCanCrossBranchShare?: boolean;
}

export class OrderTemplateSummaryRest implements IOrderTemplateSummaryRest {
    orderTemplateId?: string;
    quoteNumber?: number;
    name?: string;
    description?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IOrderTemplateSummaryRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderTemplateId = _data["orderTemplateId"];
            this.quoteNumber = _data["quoteNumber"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderTemplateSummaryRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrderTemplateSummaryRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderTemplateId"] = this.orderTemplateId;
        data["quoteNumber"] = this.quoteNumber;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderTemplateSummaryRest {
    orderTemplateId?: string;
    quoteNumber?: number;
    name?: string;
    description?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class OrganisationSampleIdentifierRest implements IOrganisationSampleIdentifierRest {
    organisationSampleIdentifierId?: string;
    name?: string;
    limbusOrganisationId?: number;
    description?: string;
    isActive?: boolean;
    sequence?: number;
    type?: string;
    sampleNameValue?: string;
    inputWidth?: number;
    isOrderTemplateSampleNameTarget?: boolean;
    validationConfiguration?: SampleIdentifierValidationConfigurationRest;

    constructor(data?: IOrganisationSampleIdentifierRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organisationSampleIdentifierId = _data["organisationSampleIdentifierId"];
            this.name = _data["name"];
            this.limbusOrganisationId = _data["limbusOrganisationId"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.sequence = _data["sequence"];
            this.type = _data["type"];
            this.sampleNameValue = _data["sampleNameValue"];
            this.inputWidth = _data["inputWidth"];
            this.isOrderTemplateSampleNameTarget = _data["isOrderTemplateSampleNameTarget"];
            this.validationConfiguration = _data["validationConfiguration"] ? SampleIdentifierValidationConfigurationRest.fromJS(_data["validationConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganisationSampleIdentifierRest {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationSampleIdentifierRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organisationSampleIdentifierId"] = this.organisationSampleIdentifierId;
        data["name"] = this.name;
        data["limbusOrganisationId"] = this.limbusOrganisationId;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["sequence"] = this.sequence;
        data["type"] = this.type;
        data["sampleNameValue"] = this.sampleNameValue;
        data["inputWidth"] = this.inputWidth;
        data["isOrderTemplateSampleNameTarget"] = this.isOrderTemplateSampleNameTarget;
        data["validationConfiguration"] = this.validationConfiguration ? this.validationConfiguration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganisationSampleIdentifierRest {
    organisationSampleIdentifierId?: string;
    name?: string;
    limbusOrganisationId?: number;
    description?: string;
    isActive?: boolean;
    sequence?: number;
    type?: string;
    sampleNameValue?: string;
    inputWidth?: number;
    isOrderTemplateSampleNameTarget?: boolean;
    validationConfiguration?: SampleIdentifierValidationConfigurationRest;
}

export class SampleIdentifierValidationConfigurationRest implements ISampleIdentifierValidationConfigurationRest {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    required?: boolean | undefined;
    regexPattern?: string;

    constructor(data?: ISampleIdentifierValidationConfigurationRest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minValue = _data["minValue"];
            this.maxValue = _data["maxValue"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.required = _data["required"];
            this.regexPattern = _data["regexPattern"];
        }
    }

    static fromJS(data: any): SampleIdentifierValidationConfigurationRest {
        data = typeof data === 'object' ? data : {};
        let result = new SampleIdentifierValidationConfigurationRest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minValue"] = this.minValue;
        data["maxValue"] = this.maxValue;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["required"] = this.required;
        data["regexPattern"] = this.regexPattern;
        return data;
    }
}

export interface ISampleIdentifierValidationConfigurationRest {
    minValue?: number | undefined;
    maxValue?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    required?: boolean | undefined;
    regexPattern?: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}